{
  "common": {
    "main": {
      "project": "Project",
      "form": "Form",
      "version": "Version",
      "formSettings": "Form Settings",
      "user": "User",
      "organization": "Organization",
      "server": "Server",
      "url": "URL"
    },
    "buttons": {
      "ok": "OK",
      "cancel": "Cancel",
      "save": "Save",
      "add": "Add",
      "edit": "Edit",
      "delete": "Delete",
      "refresh": "Refresh",
      "create": "Create",
      "submit": "Submit",
      "clear": "Clear",
      "selectAll": "Select All",
      "back": "Back",
      "next": "Next",
      "previous": "Previous",
      "close": "Close",
      "confirm": "Confirm",
      "yes": "Yes",
      "no": "No",
      "search": "Search",
      "filter": "Filter",
      "export": "Export",
      "import": "Import",
      "download": "Download",
      "upload": "Upload",
      "view": "View",
      "preview": "Preview",
      "copy": "Copy",
      "assign": "Assign",
      "unassign": "Unassign",
      "retry": "Retry",
      "loading": "Loading..."
    },
    "dialogs": {
      "cancel": "Cancel",
      "close": "Close",
      "confirm": "Confirm",
      "delete": "Delete",
      "save": "Save changes",
      "confirmTitle": "Confirm action",
      "unsavedChanges": {
        "title": "Unsaved changes",
        "message": "You have unsaved changes. Close without saving?"
      }
    },
    "table": {
      "headers": {
        "name": "Name",
        "description": "Description",
        "statistics": "Statistics",
        "status": "Status",
        "actions": "Actions",
        "createdAt": "Created Date",
        "updatedAt": "Updated Date",
        "created": "Created",
        "updated": "Updated",
        "type": "Type",
        "version": "Version",
        "id": "ID",
        "email": "Email",
        "role": "Role",
        "user": "User",
        "project": "Project",
        "organization": "Organization",
        "lastSubmission": "Last Submission",
        "server": "Server",
        "url": "URL",
        "format": "Format",
        "count": "Count",
        "size": "Size",
        "date": "Date",
        "time": "Time",
        "severity": "Severity",
        "field": "Primary Field",
        "form": "Form",
        "state": "State",
        "roles": "Roles",
        "groups": "Groups",
        "formId": "Form ID",
        "permissions": "Permissions",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "submissions": "Submissions",
        "publishedAt": "Published At"
      },
      "pagination": {
        "page": "Page",
        "of": "of",
        "perPage": "per page",
        "showing": "Showing",
        "to": "to",
        "totalEntries": "total entries",
        "resultsText": "results.",
        "perPageText": "Results per page"
      },
      "ariaLabels": {
        "viewDetails": "View details",
        "edit": "Edit",
        "delete": "Delete",
        "previousPage": "Previous page",
        "nextPage": "Next page"
      }
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "archived": "Archived",
      "draft": "Draft",
      "published": "Published",
      "pending": "Pending",
      "completed": "Completed",
      "failed": "Failed",
      "success": "Success",
      "error": "Error",
      "warning": "Warning",
      "info": "Info",
      "loading": "Loading",
      "notSet": "Not set",
      "notSpecified": "Not specified",
      "notAvailable": "N/A",
      "unknown": "Unknown",
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "messages": {
      "confirmDelete": "Are you sure you want to delete",
      "confirmDeleteWithName": "Are you sure you want to delete \"{name}\"?",
      "deleteSuccess": "Deleted successfully",
      "deleteError": "Error deleting",
      "saveSuccess": "Saved successfully",
      "saveError": "Error saving",
      "createSuccess": "Created successfully",
      "createError": "Error creating",
      "updateSuccess": "Updated successfully",
      "updateError": "Error updating",
      "error": "Error",
      "loadError": "Error loading",
      "noData": "No data",
      "noResults": "No results",
      "required": "This field is required",
      "invalidEmail": "Please enter a valid email",
      "confirmDeleteWithType": "Are you sure you want to delete \"{name}\" ({type})?",
      "bulkOperationSuccess": "Bulk operation completed successfully",
      "bulkOperationError": "Error performing bulk operation",
      "operationFailed": "Failed to perform operation",
      "unsavedChanges": "The form contains unsaved changes. Are you sure you want to close it?",
      "created": "created",
      "updated": "updated",
      "invalidUrl": "Please enter a valid URL"
    },
    "statistics": {
      "title": "Statistics",
      "subtitle": "Review organization-wide metrics, form states, and project activity.",
      "overall": "Overall Statistics",
      "byState": "Forms by State",
      "projectDetails": "Project Details",
      "projectLedger": "Project Ledger",
      "pipeline": "Pipeline",
      "projectCount": "{count} projects",
      "noActiveForms": "No active forms",
      "projects": "Projects",
      "totalForms": "Total Forms",
      "activeForms": "Active Forms",
      "submissions": "Submissions",
      "forms": "Forms",
      "lastUpdated": "Last updated",
      "noDataToDisplay": "No data to display"
    },
    "viewMode": {
      "cards": "Cards",
      "table": "Table",
      "list": "List",
      "grid": "Grid"
    },
    "time": {
      "today": "today",
      "yesterday": "yesterday",
      "thisWeek": "this week",
      "lastWeek": "last week",
      "thisMonth": "this month",
      "lastMonth": "last month",
      "allTime": "all time",
      "last7Days": "Last 7 days",
      "last30Days": "Last 30 days",
      "last90Days": "Last 90 days",
      "customRange": "Custom range",
      "startDate": "Start date",
      "endDate": "End date",
      "justNow": "Just now",
      "minutesAgo": "{count} min ago",
      "hoursAgo": "{count} h ago",
      "daysAgo": "{count} days ago",
      "never": "Never"
    },
    "placeholders": {
      "enterName": "Enter name",
      "enterDescription": "Enter description",
      "enterEmail": "Enter email",
      "enterUrl": "Enter URL",
      "search": "Search...",
      "selectOption": "Select option"
    },
    "formState": {
      "title": "Change Form State",
      "form": "Form",
      "currentStatus": "Current status",
      "newStatus": "New status",
      "pleaseSelectStatus": "Please select a status",
      "statusChangedSuccessfully": "Form status {formName} successfully changed to {status}",
      "errorChangingStatus": "Error changing form status"
    }
  },
  "admin": {
    "agent": {
      "title": "Hermes Agent",
      "subtitle": "Monitor and manage the AI agent integration",
      "back": "Back to dashboard",
      "sections": {
        "metrics": "Pulse"
      },
      "health": {
        "title": "Integration health",
        "checkNow": "Check now",
        "latency": "Latency",
        "lastCheck": "Last check"
      },
      "stats": {
        "activeSubs": "Active subscriptions",
        "activeSubsHint": "{total} total",
        "requestsToday": "Requests today",
        "tokensToday": "Tokens today",
        "nearQuota": "Orgs near quota",
        "nearQuotaHint": ">80% used"
      },
      "config": {
        "title": "Configuration (read-only)"
      },
      "jobs": {
        "title": "RQ Jobs (analytical reports)",
        "empty": "No recent jobs"
      },
      "digests": {
        "title": "Proactive digests",
        "trigger": "Trigger manually",
        "historyTitle": "Digest history",
        "historyEmpty": "No digest runs recorded yet."
      },
      "selfHeal": {
        "title": "Self-healing jobs",
        "trigger": "Run now"
      },
      "incident": {
        "title": "Needs attention",
        "banner": "Hermes or MCP integration is unhealthy. Agent features may be degraded."
      },
      "subscriptions": {
        "title": "Agent subscriptions",
        "subtitle": "Manage tiers, quotas and features per organization",
        "searchPlaceholder": "Search organization...",
        "allTiers": "All tiers",
        "editTitle": "Edit subscription",
        "resetTitle": "Reset usage",
        "resetMessage": "Reset usage counters for {name}?",
        "resetConfirm": "Reset",
        "empty": "No subscriptions found",
        "tierDefaultsTitle": "Tier defaults",
        "tierDefaultsHint": "Reference limits from backend SSOT. Changing tier in the edit form applies these values (overrides still possible).",
        "columns": {
          "org": "Organization",
          "tier": "Tier",
          "fiveHour": "5h",
          "week": "Week",
          "month": "Month",
          "features": "Features"
        },
        "tierDefaults": {
          "fiveHour": "5h (req / tok)",
          "week": "Week (req / tok)",
          "month": "Month (req / tok)"
        }
      },
      "usage": {
        "title": "Agent usage",
        "subtitle": "Invocation log across organizations",
        "orgIdPlaceholder": "Org ID",
        "allFeatures": "All features",
        "empty": "No usage events",
        "columns": {
          "time": "Time",
          "org": "Organization",
          "user": "User",
          "feature": "Feature",
          "tokens": "Tokens"
        }
      },
      "audit": {
        "title": "Tool-call audit",
        "subtitle": "MCP tool invocation log (especially write actions)",
        "orgIdPlaceholder": "Org ID",
        "toolPlaceholder": "Tool name",
        "writeOnly": "Write tools only",
        "detailTitle": "Audit detail",
        "detail": "Detail",
        "empty": "No audit logs",
        "write": "Write",
        "read": "Read",
        "columns": {
          "time": "Time",
          "org": "Organization",
          "tool": "Tool",
          "write": "Write"
        }
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Delete project",
        "message": "This cannot be undone. All linked forms will be removed.",
        "formsCount": "Forms to remove: {count}",
        "confirm": "Delete permanently"
      },
      "deleteOrganization": {
        "title": "Delete organization",
        "message": "This cannot be undone. All projects and users in this organization will be affected.",
        "confirm": "Delete permanently"
      },
      "deleteForm": {
        "title": "Delete form",
        "message": "This cannot be undone.",
        "confirm": "Delete permanently"
      },
      "deleteUser": {
        "title": "Delete user",
        "message": "This cannot be undone. The user will lose access to all organizations.",
        "confirm": "Delete permanently"
      },
      "projectDetails": "Project: {name}",
      "organizationDetails": "Organization: {name}",
      "formDetails": "Form: {name}",
      "userDetails": "User: {name}",
      "close": "Close",
      "createUser": {
        "title": "Create user"
      },
      "editUser": {
        "title": "Edit user"
      },
      "fullName": "Full name",
      "superuser": "Superuser",
      "active": "Active"
    },
    "back": "Back to dashboard",
    "chrome": {
      "sessionLabel": "Superuser · all actions logged",
      "exit": "Exit mode",
      "menuTitle": "Administration",
      "sessionWarning": "Admin session expires in {time}.",
      "extendSession": "Extend session"
    },
    "nav": {
      "groups": {
        "overview": "Overview",
        "directory": "Directory",
        "access": "Access",
        "integrations": "Integrations",
        "platform": "Platform"
      },
      "dashboard": "Dashboard",
      "analytics": "Analytics",
      "users": "Users",
      "organizations": "Organizations",
      "projects": "Projects",
      "forms": "Forms",
      "roles": "Roles & permissions",
      "permissionGroups": "Permission groups",
      "agent": "Hermes Agent",
      "agentDashboard": "Agent dashboard",
      "agentSubscriptions": "Agent subscriptions",
      "agentUsage": "Agent usage",
      "agentAudit": "Agent audit",
      "globalOdk": "Global ODK servers",
      "system": "System",
      "audit": "Audit",
      "subscriptions": "Billing"
    },
    "pagination": {
      "shown": "Showing {start} - {end} of {total}",
      "pageOf": "Page {page} of {pages}",
      "previous": "Previous",
      "next": "Next"
    },
    "common": {
      "tryAgain": "Try again",
      "showDeleted": "Show deleted",
      "hideDeleted": "Hide deleted",
      "showArchived": "Show archived",
      "hideArchived": "Hide archived",
      "allOrganizations": "All organizations",
      "allProjects": "All projects",
      "allRoles": "All roles",
      "allStatuses": "All statuses",
      "totalRecords": "Total records: {count}",
      "orgIdPrefix": "Org #{id}",
      "projectIdPrefix": "Project #{id}",
      "notSet": "Not set",
      "health": {
        "healthy": "Healthy",
        "degraded": "Degraded",
        "disabled": "Disabled",
        "unhealthy": "Unhealthy",
        "unknown": "Unknown"
      }
    },
    "pages": {
      "users": {
        "title": "User management",
        "subtitle": "View and manage all system users",
        "addUser": "Add user",
        "searchPlaceholder": "Search users...",
        "superuserBadge": "Superuser",
        "userBadge": "User",
        "statsTotal": "Total",
        "statsSuperusers": "Superusers",
        "statsOwners": "Owners",
        "statsActive": "Active",
        "loadError": "Failed to load users",
        "empty": "No users match the current filters"
      },
      "organizations": {
        "title": "Organization management",
        "subtitle": "View and manage all system organizations",
        "searchPlaceholder": "Search by organization name or description...",
        "sectionTitle": "Organizations",
        "loading": "Loading organizations...",
        "empty": "No organizations found",
        "loadError": "Failed to load organizations",
        "restored": "Organization restored",
        "restoreError": "Failed to restore organization",
        "owner": "Owner",
        "created": "Created",
        "deletedBadge": "Deleted",
        "activeBadge": "Active",
        "agentSubscription": "Agent subscription",
        "statsTotal": "Total organizations",
        "statsActive": "Active",
        "statsProjects": "Projects",
        "statsForms": "Forms"
      },
      "projects": {
        "title": "Project management",
        "subtitle": "View and manage all system projects",
        "searchPlaceholder": "Search by project name or description...",
        "sectionTitle": "Projects",
        "loading": "Loading projects...",
        "empty": "No projects found",
        "loadError": "Failed to load projects",
        "archived": "Project archived",
        "unarchived": "Project unarchived",
        "archiveError": "Failed to archive project",
        "unarchiveError": "Failed to unarchive project",
        "created": "Created",
        "archivedBadge": "Archived",
        "activeBadge": "Active",
        "statsTotal": "Total projects",
        "statsActive": "Active",
        "statsArchived": "Archived",
        "statsForms": "Forms"
      },
      "forms": {
        "title": "Form management",
        "subtitle": "View and manage all system forms",
        "searchPlaceholder": "Search by form name or XML ID...",
        "sectionTitle": "Forms",
        "loading": "Loading forms...",
        "empty": "No forms found",
        "loadError": "Failed to load forms",
        "deletedToast": "Form marked as deleted",
        "restoredToast": "Form restored",
        "deleteError": "Failed to delete form",
        "restoreError": "Failed to restore form",
        "created": "Created",
        "deletedBadge": "Deleted",
        "activeBadge": "Active",
        "importedBadge": "Imported",
        "statsTotal": "Total forms",
        "statsActive": "Active",
        "statsDeleted": "Deleted",
        "statsImported": "Imported"
      },
      "permissionGroups": {
        "title": "Permission groups",
        "subtitle": "Manage permission groups and assign them to users",
        "createGroup": "Create group",
        "sectionTitle": "Permission groups",
        "searchPlaceholder": "Search groups...",
        "emptyTitle": "No permission groups found",
        "emptyBody": "Create the first permission group to get started",
        "emptyFilter": "No groups match the current search",
        "deleteTitle": "Delete group",
        "deleteMessage": "Are you sure you want to delete group \"{name}\"? This cannot be undone.",
        "restoreTitle": "Restore",
        "users": "Users",
        "statsTotal": "Total groups",
        "statsActive": "Active groups",
        "statsAssignments": "Assignments",
        "loadError": "Failed to load permission groups",
        "restored": "Group \"{name}\" restored",
        "deleted": "Permission group deleted",
        "saved": "Permission group saved",
        "restoreError": "Failed to restore permission group",
        "deleteError": "Failed to delete permission group",
        "modal": {
          "createTitle": "Create permission group",
          "editTitle": "Edit permission group",
          "createHeader": "New permission group",
          "editHeader": "Edit group",
          "createSubtitle": "Create a new group with a set of roles",
          "editSubtitle": "Modify permission group parameters",
          "nameLabel": "Group name",
          "namePlaceholder": "Enter group name",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Enter group description",
          "activeLabel": "Group is active",
          "activeHint": "Inactive groups cannot be assigned to users",
          "rolesTitle": "Group roles",
          "rolesSubtitle": "Select roles to include in this group",
          "selectAtLeastOneRole": "Select at least one role",
          "selectedRolesTitle": "Selected roles",
          "clickToRemove": "Click on a role to remove it from the group",
          "validation": {
            "nameRequired": "Name is required",
            "nameMinLength": "Name must contain at least 2 characters",
            "nameMaxLength": "Name must not exceed 50 characters"
          },
          "toasts": {
            "createSuccess": "Permission group created successfully",
            "updateSuccess": "Permission group updated successfully",
            "saveError": "Error saving permission group"
          }
        },
        "groupUsersModal": {
          "title": "Users in group \"{name}\"",
          "noDescription": "No description available",
          "rolesCount": "Roles in group: {count}",
          "usersCount": "Users in group ({count})",
          "empty": "No users in this group",
          "noName": "Unnamed",
          "active": "Active",
          "inactive": "Inactive",
          "superuser": "Superuser",
          "owner": "Owner",
          "loadError": "Error loading group users"
        }
      },
      "globalOdkServers": {
        "title": "Global ODK servers",
        "subtitle": "Create and manage system-wide ODK servers",
        "createServer": "Create server",
        "searchPlaceholder": "Search by name, URL, or username...",
        "empty": "No global ODK servers",
        "emptyHint": "Create the first global ODK server to get started.",
        "emptyFilter": "No servers match the current search",
        "defaultBadge": "Default",
        "statsTotal": "Total servers",
        "statsTotalHint": "{count} (+{active} active)",
        "statsGlobal": "Global",
        "statsDefault": "Default",
        "columns": {
          "server": "Server",
          "user": "User",
          "visibility": "Visibility"
        },
        "visibility": {
          "GLOBAL": "Global",
          "ORGANIZATION": "Organization",
          "SHARED": "Shared"
        },
        "actions": {
          "test": "Test connection",
          "refreshToken": "Refresh token",
          "setDefault": "Set as default"
        },
        "testTitle": "Connection test result",
        "testOk": "Connection successful",
        "testFail": "Connection failed",
        "testMethod": "Method:",
        "testProjects": "Project count:",
        "testing": "Testing connection...",
        "refreshTokenTitle": "Refresh API token",
        "refreshTokenBody": "Enter the password to refresh the API token for server",
        "password": "Password",
        "passwordPlaceholder": "Enter password",
        "refreshTokenAction": "Refresh token",
        "requiredField": "This field is required",
        "deleteTitle": "Delete server",
        "deleteMessage": "Delete server \"{name}\"? This cannot be undone.",
        "setDefaultTitle": "Set default server",
        "setDefaultMessage": "Set \"{name}\" as the global default ODK server?",
        "setDefaultConfirm": "Set default",
        "toastCreated": "Server created",
        "toastUpdated": "Server updated",
        "toastDeleted": "Server deleted",
        "toastTestOk": "Connection successful",
        "toastTokenRefreshed": "API token refreshed",
        "toastDefaultSet": "Global default server updated",
        "form": {
          "createTitle": "Create global ODK server",
          "editTitle": "Edit global ODK server",
          "nameLabel": "Server name",
          "namePlaceholder": "Enter server name",
          "urlLabel": "Server URL",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Username",
          "usernamePlaceholder": "Enter username",
          "passwordLabel": "Password",
          "passwordPlaceholder": "Enter password",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Server description (optional)",
          "globalDefaultLabel": "Global default server",
          "activeLabel": "Active server",
          "updateButton": "Update"
        }
      },
      "subscriptions": {
        "title": "Billing subscriptions",
        "subtitle": "SaaS billing and payment plans (not Hermes Agent quotas)",
        "stubBadge": "Coming soon",
        "stubBody": "Self-serve billing is under development. Organization plan tiers (Free / Pro / Enterprise / Custom) are managed today via Hermes Agent → Subscriptions.",
        "stubAgentHint": "Org product plan: export formats, share links, auto-reports, capacity limits, AI quotas, and 14-day Pro trial.",
        "openAgentSubscriptions": "Open organization plans"
      },
      "audit": {
        "title": "Action audit",
        "subtitle": "Log of administrative actions by superusers",
        "loadError": "Failed to load the audit log.",
        "empty": "No audit records yet",
        "emptyFilter": "No records match the current search",
        "searchPlaceholder": "Search by user, action, or details...",
        "time": "Time",
        "user": "User",
        "action": "Action",
        "actionKey": "Action key",
        "details": "Details",
        "detailTitle": "Audit entry"
      },
      "system": {
        "title": "System health",
        "subtitle": "Infrastructure diagnostics — status, latency, and runtime details",
        "loadError": "Failed to load system status.",
        "attentionTitle": "Needs attention",
        "attentionComponent": "{component}: {status}",
        "openAgent": "Open Agent",
        "componentsTitle": "Components",
        "serverInfo": "Runtime details",
        "version": "Version",
        "uptime": "Process uptime",
        "dbConnections": "DB connections (active)",
        "dbPool": "DB pool size",
        "dbLatency": "DB latency",
        "apiLatency": "API latency",
        "components": {
          "server": "Server",
          "database": "Database",
          "redis": "Redis",
          "api": "API",
          "agent": "Hermes Agent"
        }
      },
      "analytics": {
        "title": "Analytics dashboard",
        "subtitle": "System-wide and user analytics",
        "loadError": "Failed to load analytics. Showing zero values.",
        "totalUsers": "Total users",
        "thisMonth": "+{count} this month",
        "organizations": "Organizations",
        "growthPct": "{pct}% growth",
        "totalProjects": "Total projects",
        "totalForms": "Total forms",
        "submissions": "Submissions",
        "userGrowth": "User growth (by month)",
        "orgActivity": "Organization activity (by projects)",
        "noData": "No data",
        "topOrgs": "Top organizations",
        "projectsCount": "{count} projects",
        "noOrgs": "No organizations",
        "recentActivity": "Recent activity",
        "noRecent": "No recent activity",
        "systemHealth": "System health",
        "resources": "Resource usage",
        "orgs": "Organizations",
        "projects": "Projects",
        "forms": "Forms",
        "health": {
          "api": "API",
          "database": "Database",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Hermes Agent"
        }
      },
      "roles": {
        "title": "Roles & permissions",
        "subtitle": "Platform role catalog — building blocks for permission groups",
        "searchPlaceholder": "Search roles...",
        "loadError": "Could not load roles.",
        "emptyTitle": "No roles found",
        "emptyFilter": "No roles match the current search",
        "openGroups": "Permission groups",
        "system": "System",
        "custom": "Custom",
        "unused": "Not used in any group",
        "columns": {
          "role": "Role",
          "description": "Description",
          "usedIn": "Used in groups",
          "type": "Type"
        },
        "labels": {
          "project_member": "Project member"
        },
        "descriptions": {
          "fallback": "No description available.",
          "manager": "Full project management and quality oversight.",
          "project_member": "Minimal project access — name and forms, without submission data.",
          "data_viewer": "Read-only access to submissions, monitoring, and QC review.",
          "data_collector": "Collect and submit field data.",
          "data_downloader": "Export and download submission data.",
          "data_analyst": "QC operations and data analysis.",
          "form_designer": "Create and manage XLSForms.",
          "qc_editor": "Edit QC results and findings."
        }
      }
    },
    "dashboard": {
      "title": "Overview",
      "subtitle": "Platform pulse and recent admin activity",
      "errors": {
        "stats": "Could not load system metrics. Showing zeros.",
        "health": "Could not load system health.",
        "activities": "Could not load recent activity."
      },
      "attention": {
        "title": "Needs attention",
        "server": "Server reports an unhealthy state.",
        "database": "Database reports an unhealthy state.",
        "redis": "Redis reports an unhealthy state.",
        "api": "API reports an unhealthy state.",
        "agent": "Hermes Agent status: {status}.",
        "failedLogins": "{count} failed login attempts in the last 24 hours.",
        "openSystem": "Open System",
        "openAgent": "Open Agent",
        "openAudit": "Open Audit"
      },
      "sections": {
        "metrics": "Directory",
        "health": "Health",
        "activity": "Recent activity"
      },
      "metrics": {
        "users": "Users",
        "usersHint": "+{count} today",
        "orgs": "Organizations",
        "orgsHint": "+{count} this week",
        "projects": "Projects",
        "projectsHint": "{count} active",
        "failedLogins": "Failed logins",
        "failedLoginsHint": "Last 24 hours"
      },
      "health": {
        "server": "Server",
        "database": "Database",
        "redis": "Redis",
        "api": "API",
        "agent": "Hermes Agent",
        "connections": "{count} connections",
        "latency": "{ms} ms",
        "agentHint": "{count} req today"
      },
      "activity": {
        "viewAll": "View audit",
        "empty": "No recent admin activity"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Loading agent subscription...",
      "working": "Agent is working..."
    },
    "features": {
      "reports": "Reports",
      "qc": "QC assist",
      "xlsform": "XLSForm",
      "share_links": "Share links",
      "auto_reports": "Auto-reports",
      "qc_rules": "QC rules"
    },
    "entitlement": {
      "title": "Upgrade required",
      "body": "This capability is not included in your current organization plan. Contact us to upgrade to Pro or Enterprise.",
      "contactUs": "Contact us to upgrade your plan."
    },
    "errors": {
      "generic": "Failed to call the agent.",
      "endpointNotFound": "This agent feature is not available on the running backend. Restart the backend dev server (.\\scripts\\dev.ps1).",
      "timeout": "The agent did not respond in time. XLSForm assist may take up to 10 minutes — try again.",
      "featureUnavailable": "This feature is not available on your plan.",
      "quotaExceeded": "Agent quota exceeded for this period.",
      "disabled": "The AI agent is temporarily disabled.",
      "mcpUnavailable": "Hermes cannot see udacapi MCP tools. Register MCP on CT253 (grant-udacapi-mcp.sh) and verify relay :8101 → backend :8100. See runbooks/hermes-udacapi-agent-integration.md."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Monthly request limit reached",
          "tokens": "Monthly token limit reached"
        },
        "five_hour": {
          "requests": "5-hour request limit reached",
          "tokens": "5-hour token limit reached"
        },
        "weekly": {
          "requests": "Weekly request limit reached",
          "tokens": "Weekly token limit reached"
        }
      },
      "usageLine": "{used} of {limit} used",
      "resetsAt": "Available again {relative} ({absolute})",
      "resetsUnknown": "Try again later or contact your administrator to increase limits.",
      "viewSubscription": "View quota details",
      "sendBlocked": "Agent quota exhausted — wait for the limit to reset.",
      "nearLimit": "Agent quota almost exhausted ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Feature locked",
      "lockedDescription": "\"{feature}\" is available on the {tier} plan and above."
    },
    "subscription": {
      "sectionTitle": "Organization plan",
      "sectionDescription": "Your organization's plan tier, AI quotas, and enabled features.",
      "currentTier": "Current tier",
      "active": "Active",
      "inactive": "Inactive",
      "features": "Enabled features",
      "tier": "Tier",
      "capabilities": "Capabilities",
      "billingPeriod": "Billing period started",
      "trialActive": "Pro trial active until {date}. After that you stay on Free with plan limits.",
      "submissionsSoftExceeded": "Submission volume is above your plan soft limit. Contact us to upgrade — field sync is not blocked.",
      "requests": "Requests this period",
      "requests_5h": "Requests (last 5h)",
      "requests_weekly": "Requests (last week)",
      "requests_badge": "req",
      "requests_5h_badge": "req (5h)",
      "requests_weekly_badge": "req (wk)",
      "tokens": "Tokens this period",
      "tokens_5h": "Tokens (last 5h)",
      "tokens_weekly": "Tokens (last week)",
      "nearQuotaTitle": "Near quota limit",
      "nearQuotaDescription": "More than 80% of the monthly quota is used. Contact your administrator to increase limits.",
      "tiers": {
        "free": "Free",
        "pro": "Pro",
        "enterprise": "Enterprise"
      }
    },
    "report": {
      "title": "AI report for PM",
      "description": "Submission summary prepared by the UDA AI agent.",
      "period": "Period (days)",
      "generate": "Generate report",
      "generating": "The agent is preparing the report...",
      "empty": "Click \"Generate report\" to get a summary.",
      "modeSummary": "Summary",
      "modeAnalytical": "Analytical",
      "modeScheduled": "Scheduled",
      "quotaExceeded": "Agent quota exceeded for this period.",
      "featureUnavailable": "AI reports are not available on your plan.",
      "error": "Failed to get a report from the agent.",
      "healthAlerts": "Form health notes",
      "copy": "Copy report",
      "copied": "Copied",
      "copyFailed": "Could not copy to clipboard.",
      "viewFormatted": "Formatted",
      "viewRaw": "Markdown",
      "auto": {
        "latest": "Latest",
        "history": "History",
        "generateNow": "Generate now",
        "manageTemplates": "Manage templates",
        "selectTemplate": "Template",
        "latestEmpty": "No completed template reports yet. Choose a template and click Generate now.",
        "historyEmpty": "No report runs yet.",
        "view": "View",
        "viewTitle": "Report",
        "close": "Close",
        "generating": "Generating scheduled report...",
        "done": "Report ready.",
        "statusLabel": "Status: {status}",
        "emptyResult": "The report finished but returned no content.",
        "runFailed": "Report generation failed.",
        "timeout": "The report took too long. Try again later.",
        "noContent": "No report content available.",
        "unknownTemplate": "Unknown template",
        "trigger": {
          "scheduled": "Scheduled",
          "event": "Event",
          "manual": "Manual"
        },
        "status": {
          "pending": "Pending",
          "running": "Running",
          "done": "Done",
          "failed": "Failed"
        }
      },
      "templates": {
        "title": "Report templates",
        "subtitle": "Configure scheduled and on-demand AI report prompts for this organization.",
        "create": "New template",
        "createTitle": "Create report template",
        "edit": "Edit",
        "editTitle": "Edit report template",
        "formSubtitle": "Define what the report covers, when it runs, and who receives it.",
        "sections": {
          "content": "Report content",
          "schedule": "Schedule",
          "delivery": "Delivery and scope"
        },
        "seed": "Seed defaults",
        "seeded": "Seeded {count} template(s).",
        "empty": "No templates yet. Seed defaults or create one.",
        "active": "Active",
        "inactive": "Inactive",
        "cron": "Schedule",
        "sendByEmail": "Send by email",
        "deactivate": "Deactivate",
        "deactivated": "Template deactivated.",
        "activate": "Activate",
        "activated": "Template activated.",
        "save": "Save",
        "saved": "Template saved.",
        "saveError": "Could not save the template.",
        "loadError": "Could not load report templates.",
        "validationRequired": "Name and prompt are required.",
        "recipientsPlaceholder": "Select organization members",
        "recipientsRequired": "Select at least one recipient when email is enabled.",
        "promptHint": "Access to organization data, selected forms and the reporting period is added automatically.",
        "allFormsPlaceholder": "All forms (leave empty)",
        "advancedMode": "Custom prompt (advanced, Jinja2)",
        "fields": {
          "name": "Name",
          "audience": "Audience",
          "prompt": "Report instructions",
          "responseLanguage": "Response language",
          "recipients": "Recipients",
          "formScope": "Forms"
        },
        "schedule": {
          "label": "Schedule",
          "none": "No schedule",
          "daily": "Daily",
          "weekly": "Weekly",
          "monthly": "Monthly",
          "custom": "Custom (cron)",
          "time": "Time",
          "weekday": "Day of week",
          "dayOfMonth": "Day of month",
          "customCron": "Cron expression",
          "humanDaily": "Daily at {time}",
          "humanWeekly": "Every {weekday} at {time}",
          "humanMonthly": "Monthly on day {day} at {time}",
          "weekdays": {
            "0": "Sunday",
            "1": "Monday",
            "2": "Tuesday",
            "3": "Wednesday",
            "4": "Thursday",
            "5": "Friday",
            "6": "Saturday"
          }
        },
        "audience": {
          "pm": "Project manager",
          "field_coord": "Field coordinator",
          "statistician": "Statistician",
          "executive": "Executive"
        }
      }
    },
    "chat": {
      "modeAsk": "Ask agent",
      "description": "Ask questions about this form's schema, submissions, analytics, QC rules, and sync status. Answers are based on live data; sample submissions may contain personal fields.",
      "question": "Your question",
      "placeholder": "e.g. How many submissions in the last 7 days? What fields does this form have?",
      "send": "Send",
      "empty": "Ask a question about this form's data.",
      "you": "You",
      "agent": "Agent",
      "generating": "The agent is looking up form data...",
      "sendHint": "Enter to send · Shift+Enter for a new line"
    },
    "analytical": {
      "generate": "Run analytical report",
      "empty": "Run an analytical report for in-depth form analysis.",
      "queued": "Report queued...",
      "status": "Status: {status}",
      "done": "Report ready.",
      "failed": "Failed to generate the analytical report.",
      "emptyResult": "The report finished but returned no content.",
      "timeout": "The analytical report took too long. Check that the agent reports worker is running.",
      "workerHint": "The job is still queued. Start the agent-reports-worker service (docker compose up -d agent-reports-worker) and try again."
    },
    "qc": {
      "title": "AI QC assistant",
      "description": "Describe a check in plain language — the agent will draft a QC rule.",
      "checkDescription": "Check description",
      "checkPlaceholder": "e.g. respondent age must be between 18 and 65",
      "suggest": "Suggest rule",
      "generating": "The agent is drafting a rule...",
      "applyDraft": "Apply draft to form",
      "draftApplied": "Draft applied to the rule form.",
      "draftPreview": "Suggested rule",
      "viewRawResponse": "View full agent response",
      "sendHint": "Enter to suggest · Shift+Enter for a new line",
      "noDraftParsed": "Could not parse a rule draft JSON from the agent response.",
      "validationWarnings": "Validation notes ({count}):",
      "starterPack": {
        "title": "Starter QC rules",
        "description": "Review the form and get a suggested set of rules to begin validation.",
        "focus": "Focus",
        "focusAll": "Balanced mix",
        "focusRequired": "Required fields only",
        "focusConstraints": "Constraints only",
        "maxRules": "Max rules",
        "suggest": "Suggest starter rules",
        "generating": "Reviewing the form and drafting rules...",
        "apply": "Apply this rule",
        "empty": "No valid rule drafts were returned. Try again or use single-rule suggest above.",
        "skippedHint": "{count} proposed rule(s) were skipped (duplicate, invalid, or over limit)."
      }
    },
    "xlsform": {
      "openButton": "AI XLSForm",
      "title": "AI XLSForm assistant",
      "description": "Upload a questions file or describe the task — the agent will draft, test, and request publish confirmation.",
      "instruction": "Instruction for the agent",
      "instructionPlaceholder": "e.g. create a 5-question satisfaction survey form",
      "empty": "Describe what form you need or upload a file — the agent will draft and test it.",
      "send": "Send",
      "sendHint": "Enter to send · Shift+Enter for a new line",
      "working": "The agent is working on the task...",
      "you": "You",
      "agent": "Agent",
      "publishTitle": "Publish confirmation",
      "publishDescription": "The agent requested publishing a draft. Confirm manually — publish cannot proceed without confirmation.",
      "formId": "Form ID (xmlFormId)",
      "versionOptional": "Version (optional)",
      "confirmPublish": "Confirm publish",
      "upload": {
        "hint": "Attach Excel/CSV, Word, or text with your questions (max 5 MB)",
        "attachAria": "Attach file",
        "removeAttachment": "Remove attachment",
        "selected": "File: {name}",
        "attachmentPrefix": "[file: {name}]"
      },
      "session": {
        "resumeBanner": "You have an unfinished AI XLSForm session (draft: {formId})",
        "resumeButton": "Resume",
        "startNewButton": "Start new",
        "dismissButton": "Dismiss",
        "dismissError": "Could not dismiss the session. Try again.",
        "historyButton": "Previous sessions",
        "historyAriaLabel": "Session history",
        "historyTitle": "AI XLSForm sessions",
        "historyHint": "Sessions from the last 7 days. Continue a draft or view a published session.",
        "historyEmpty": "No previous sessions for this project.",
        "historyFormColumn": "Draft form",
        "historyStatusColumn": "Status",
        "historyUpdatedColumn": "Last updated",
        "historyPreviewColumn": "Latest note",
        "historyMessagesColumn": "Messages",
        "historyActionsColumn": "Actions",
        "continueButton": "Continue",
        "viewButton": "View",
        "clearDismissedButton": "Clear dismissed",
        "clearFailedButton": "Clear failed",
        "clearNonPublishedButton": "Clear non-published",
        "continueError": "Could not resume this session. Try again.",
        "cleanupError": "Could not clear previous sessions. Try again.",
        "forkedFrom": "Forked from previous version",
        "lineagePublished": "Published version",
        "cleanupConfirm": {
          "dismissed": {
            "title": "Clear dismissed sessions?",
            "message": "This permanently deletes dismissed sessions for this project. Published sessions are kept."
          },
          "failed": {
            "title": "Clear failed sessions?",
            "message": "This permanently deletes failed sessions for this project."
          },
          "non_published": {
            "title": "Clear all non-published sessions?",
            "message": "This permanently deletes active, dismissed, and failed sessions. Published sessions are kept."
          }
        },
        "readOnlyHint": "This session was published. You can review the chat history but cannot send new messages.",
        "draftUnknown": "unnamed",
        "status": {
          "active": "Active",
          "discarded": "Dismissed",
          "failed": "Failed",
          "published": "Published"
        }
      },
      "job": {
        "canClose": "You can close this window — your session will continue in the background.",
        "elapsed": "Working… {time}",
        "agentWorking": "The agent is processing your request (LLM and MCP tools). This step can take several minutes.",
        "longWait": "Still working — check that the LLM proxy and Hermes MCP relay are healthy if this takes longer than 10 minutes.",
        "timeout": "The form assistant did not finish in time. The failed session was reset; try again to start a fresh session.",
        "failed": "The form assistant failed. Try again.",
        "phases": {
          "queued": "Queued",
          "planning": "Analyzing your request",
          "editing": "Editing form questions",
          "uploading_draft": "Creating draft form",
          "testing_draft": "Testing draft",
          "finalizing": "Preparing response",
          "completed": "Done"
        },
        "queuedFallback": "Worker did not pick up the job yet — the server will retry in-process shortly."
      },
      "preview": {
        "tabChat": "Chat",
        "tabPreview": "Preview",
        "loading": "Loading the form preview…",
        "empty": "No draft to preview yet. Ask the assistant to create or edit the form.",
        "error": "Could not load the form preview.",
        "submitError": "Could not send the test submission."
      },
      "workbench": {
        "tabChat": "Chat",
        "tabPreview": "Preview",
        "downloadDraft": "Download draft",
        "downloadPublished": "Download published",
        "uploadExcel": "Upload Excel",
        "uploadConfirmTitle": "Replace form from Excel?",
        "uploadConfirmMessage": "This will replace the current draft questions with the uploaded spreadsheet.",
        "uploadConfirmDetail": "The assistant session history is kept; only the form structure changes.",
        "startRevision": "Start revision",
        "openForm": "Open form in project",
        "downloadError": "Could not download the Excel file.",
        "importError": "Could not import the Excel file.",
        "forkError": "Could not start a revision session."
      },
      "settings": {
        "title": "Form settings",
        "hint": "Form ID becomes the ODK xmlFormId. It must be unique in this project. Avoid changing it after publish.",
        "formTitle": "Form title",
        "formId": "Form ID (xmlFormId)",
        "save": "Save settings",
        "saved": "Settings saved",
        "conflict": "This Form ID is already used in the project.",
        "suggestion": "Try: {id}",
        "saveError": "Could not save form settings.",
        "saveBusy": "Could not save while the agent job holds the draft. Wait for the job to finish, or try again."
      },
      "header": {
        "newForm": "New form",
        "version": "Spec v{version}",
        "status": {
          "idea": "Planning",
          "draft": "Draft ready",
          "publish": "Waiting publish",
          "published": "Published",
          "conflict": "Needs attention",
          "failed": "Failed"
        }
      },
      "timeline": {
        "title": "System events"
      },
      "changes": {
        "title": "Change summary"
      },
      "validation": {
        "title": "Validation",
        "empty": "Validation will appear after the first draft update.",
        "noIssues": "No blocking issues detected.",
        "applySuggestedId": "Apply suggested ID",
        "editSettings": "Edit settings",
        "status": {
          "ok": "OK",
          "warning": "Warning",
          "error": "Error"
        }
      },
      "recovery": {
        "retryLast": "Retry last request",
        "startFresh": "Start new session"
      }
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Sync completed: {formName}. Processed {count} of {total} records",
      "syncError": "Sync error: {formName}. {error}",
      "formStatusChange": "Form status changed: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Scheduler: {status}. Active jobs: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "QC validation completed: {instanceId}. Rules: {totalRules}, passed: {passedRules}, errors: {errorRules}, warnings: {warningRules}",
      "projectStatusSummary": "Critical changes: {errorProjects} projects with errors, {errorForms} forms with errors out of {totalProjects} projects and {totalForms} forms"
    },
    "connection": {
      "connected": "WebSocket connected",
      "disconnected": "WebSocket disconnected",
      "reconnecting": "Reconnecting...",
      "error": "WebSocket error: {error}",
      "maxRetriesReached": "Maximum number of reconnection attempts reached"
    },
    "connected": "Connected",
    "disconnected": "Disconnected",
    "realTimeUpdates": "Real-time updates"
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "odkOptions": {
    "themes": {
      "light": "Light",
      "dark": "Dark"
    },
    "navigation": {
      "swipe": "Swipe",
      "buttons": "Buttons",
      "swipe_buttons": "Swipe + Buttons"
    },
    "formUpdate": {
      "manual": "Manual",
      "previously_downloaded": "Previously downloaded",
      "match_exactly": "Match exactly"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "Every 15 minutes",
      "every_one_hour": "Every 1 hour",
      "every_six_hours": "Every 6 hours",
      "every_24_hours": "Every 24 hours"
    },
    "autosend": {
      "off": "Off",
      "wifi_only": "Wi‑Fi only",
      "cellular_only": "Cellular only",
      "wifi_and_cellular": "Wi‑Fi and Cellular"
    },
    "constraintBehavior": {
      "on_swipe": "On swipe",
      "on_finalize": "On finalize"
    },
    "imageSizes": {
      "original": "Original",
      "very_small": "Very small",
      "small": "Small",
      "medium": "Medium",
      "large": "Large"
    },
    "guidanceHint": {
      "no": "No",
      "yes": "Yes",
      "yes_collapsed": "Yes (collapsed)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Normal",
      "terrain": "Terrain",
      "hybrid": "Hybrid",
      "satellite": "Satellite",
      "light": "Light",
      "dark": "Dark",
      "satellite_streets": "Satellite + streets",
      "outdoors": "Outdoors",
      "topographic": "Topographic",
      "positron": "Positron",
      "dark_matter": "Dark matter"
    },
    "fontSizes": {
      "small": "Small",
      "normal": "Normal",
      "large": "Large",
      "xl": "XL",
      "xxl": "XXL"
    }
  },
  "users": {
    "title": "User Management",
    "subtitle": "Manage organization members, filter by activity, and update access records.",
    "searchUser": "Search user",
    "addUser": "Add user",
    "editUser": "Edit user",
    "deleteUser": "Delete user",
    "firstName": "First name",
    "lastName": "Last name",
    "fullName": "Full name",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "enterEmail": "Enter email",
    "userCreated": "User created successfully",
    "userUpdated": "User updated successfully",
    "userDeleted": "User deleted successfully",
    "confirmDeleteUser": "Are you sure you want to delete this user?",
    "projectSelection": {
      "archived": "Archived",
      "noProjects": "No projects available",
      "noProjectsDescription": "No projects available for assignment",
      "errorLoadingProjects": "Error loading projects"
    },
    "admin": "Administrator",
    "data_collector": "Data Collector",
    "supervisor": "Supervisor",
    "user": "User",
    "owner": "Owner",
    "isClient": "Client",
    "active": "Active",
    "inactive": "Inactive",
    "refresh": "Refresh",
    "unsavedChanges": "Form has unsaved changes. Are you sure you want to close it?",
    "validation": {
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 8 characters",
      "confirmPasswordRequired": "Please confirm password",
      "passwordsDontMatch": "Passwords do not match"
    },
    "editUserDescription": "Update user details",
    "addUserDescription": "Create a new user in the system",
    "basicInformation": "Basic Information",
    "fullNamePlaceholder": "Enter full name",
    "passwordSettings": "Password Settings",
    "passwordPlaceholder": "Enter password",
    "confirmPasswordPlaceholder": "Confirm password",
    "passwordHelp": "Password must be at least 8 characters long",
    "userSettings": "User Settings",
    "clientUserDescription": "Client user has limited access",
    "inactiveUserDescription": "Inactive users cannot log into the system",
    "noName": "No name"
  },
  "user": {
    "system": "System",
    "account": "Account",
    "explore": "Explore",
    "profile": "Profile",
    "logout": "Logout",
    "settings": "Settings",
    "projects": "Projects",
    "faq": "Help",
    "help": "Help",
    "helpAndSupport": "Help & Support",
    "administration": "Administration"
  },
  "odkSync": {
    "dashboard": {
      "title": "Sync Workbench"
    },
    "workbench": {
      "contextHint": "Monitor ingestion from ODK servers and manage sync cursors across your organization.",
      "live": "Live updates",
      "reconnect": "Reconnect",
      "loading": "Loading sync data…",
      "schedulerPill": "Scheduler",
      "schedulerActive": "Active",
      "schedulerPaused": "Paused",
      "schedulerStopped": "Stopped",
      "statusLive": "Live",
      "statusOffline": "Offline",
      "statusSchedulerActive": "Active",
      "statusSchedulerPaused": "Paused",
      "statusSchedulerStopped": "Stopped",
      "createShort": "New",
      "pipeline": {
        "ariaLabel": "Sync pipeline status",
        "scheduler": "Scheduler",
        "schedulerActive": "Running on schedule",
        "schedulerPaused": "Paused — submissions not syncing",
        "pull": "Last pull",
        "cursors": "Cursors",
        "cursorsHint": "{count} forms tracked",
        "cursorsEmpty": "No cursors yet"
      }
    },
    "table": {
      "emptyState": "No sync cursors yet. Create one to start pulling submissions."
    },
    "scheduler": {
      "title": "Sync Scheduler",
      "pauseScheduler": "Pause Scheduler",
      "resumeScheduler": "Resume Scheduler",
      "pausedMessage": "ODK data synchronization is currently paused. New submissions will not be synced until resumed."
    },
    "managerScope": {
      "title": "Viewing sync data",
      "message": "You are viewing sync data for {count} project(s) you manage. You can only see and control synchronization for projects where you have the manager role."
    },
    "statistics": {
      "title": "Sync Statistics",
      "totalCursors": "Total Cursors",
      "lastSync": "Last Sync"
    },
    "cursors": {
      "title": "Sync Cursors",
      "viewModes": {
        "cards": "Cards",
        "table": "Table",
        "projects": "By Projects",
        "list": "List"
      },
      "actions": {
        "clear": "Clear",
        "bulkSync": "Bulk Sync ({count})",
        "bulkReset": "Bulk Reset ({count})",
        "createCursor": "Create Cursor"
      }
    },
    "auto": {
      "managed": "Auto",
      "manual": "Manual",
      "enableAuto": "Enable Auto ({count})",
      "disableAuto": "Disable Auto ({count})",
      "reason": "Reason",
      "reasons": {
        "importedActive": "Imported active form",
        "createdActive": "Created active form",
        "uploadedActive": "Uploaded active form",
        "formOpened": "Form opened",
        "formClosed": "Form closed",
        "formReopened": "Form reopened",
        "newFormOpened": "New form opened",
        "migrated": "Migrated",
        "formNotFound": "Form not found",
        "manualOverride": "Manual override",
        "formDeleted": "Form deleted",
        "importedFormDeleted": "Imported form deleted"
      }
    },
    "projectSummary": {
      "forms": "Forms: {count}",
      "lastSync": "Last Sync",
      "active": "Active: {count}",
      "errors": "Errors: {count}",
      "inactive": "Inactive: {count}",
      "noProjects": "No Projects",
      "createFirstCursor": "Create your first sync cursor"
    },
    "projectResponsible": {
      "responsible": "Responsible",
      "notAssigned": "Not assigned",
      "assign": "Assign",
      "remove": "Remove",
      "assignModal": {
        "title": "Assign responsible for project \"{project}\"",
        "selectUser": "Select user",
        "selectUserPlaceholder": "Select responsible person",
        "assign": "Assign",
        "noUsers": "No available users",
        "noUsersMessage": "There are no users in the organization to assign as responsible for the project."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Create Sync Cursor",
        "server": "Server",
        "project": "Project",
        "xmlForm": "XML Form",
        "serverPlaceholder": "Select server",
        "projectPlaceholder": "Select project",
        "xmlFormPlaceholder": "Select form"
      },
      "manualSync": {
        "title": "Manual Sync",
        "selectCursors": "Select Cursors",
        "forceFullSync": "Force Full Sync",
        "maxConcurrent": "Max Concurrent Syncs",
        "startSync": "Start Sync"
      }
    },
    "messages": {
      "schedulerPaused": "ODK sync scheduler paused",
      "schedulerResumed": "ODK sync scheduler resumed",
      "cursorCreated": "Sync cursor created successfully",
      "manualSyncTriggered": "Manual sync triggered successfully",
      "cursorReset": "Cursor reset successfully",
      "bulkResetSuccess": "Successfully reset {count} cursors",
      "selectCursorsForSync": "Please select at least one cursor for sync",
      "never": "Never"
    },
    "errors": {
      "failedToLoadSyncData": "Failed to load sync data",
      "failedToControlScheduler": "Failed to control scheduler",
      "failedToCreateCursor": "Failed to create sync cursor",
      "failedToTriggerManualSync": "Failed to trigger manual sync",
      "failedToResetCursor": "Failed to reset cursor",
      "failedToResetSomeCursors": "Failed to reset some cursors"
    },
    "filters": {
      "showAllForms": "Show all cursors",
      "filteringTitle": "Cursor filtering",
      "filteringMessage": "Showing {filtered} of {total} cursors. Hidden {hidden} inactive cursors."
    },
    "formStatus": {
      "title": "Form status and optimization",
      "checkStatuses": "Check statuses",
      "statusLabels": {
        "open": "Open",
        "closing": "Closing",
        "closed": "Closed",
        "unknown": "Unknown"
      },
      "cards": {
        "title": "Form status",
        "description": "Check and optimize cursors",
        "refresh": "Refresh"
      },
      "loading": "Loading...",
      "autoCheckInterval": "5 minutes",
      "lastCheck": "Automatically every 5 minutes",
      "benefits": {
        "autoDisable": "Automatic cursor disabling for closed forms",
        "resourceOptimization": "Synchronization resource optimization",
        "performanceImprovement": "Improved performance"
      },
      "messages": {
        "checkStarted": "Form status check started",
        "checkError": "Error checking form statuses",
        "enableError": "Error enabling cursors",
        "disableError": "Error disabling cursors"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "QC Dashboard - ODK Data Quality",
      "description": "Monitoring ODK submissions data quality using validation rules"
    },
    "statistics": {
      "totalRules": "Total Rules",
      "activeRules": "Active Rules",
      "inactiveRules": "Inactive Rules",
      "recentValidations": "Recent Validations"
    },
    "sections": {
      "rulesByType": "Rules by Type",
      "rulesBySeverity": "Rules by Severity",
      "qcRules": "QC Rules"
    },
    "filters": {
      "allTypes": "All Types",
      "allLevels": "All Levels",
      "allStatuses": "All Statuses",
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "createRule": "Create Rule",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "clearSelection": "Clear Selection"
    },
    "ruleTypes": {
      "required": "Required",
      "constraint": "Constraint",
      "calculation": "Calculation",
      "custom": "Custom"
    },
    "severityLevels": {
      "error": "Error",
      "warning": "Warning",
      "info": "Info"
    },
    "messages": {
      "noRuleTypeData": "No rule type data available",
      "noSeverityData": "No severity data available",
      "ruleUpdated": "Rule updated successfully",
      "ruleCreated": "Rule created successfully",
      "ruleSaveError": "Error saving rule",
      "ruleLoadError": "Error loading data",
      "ruleStatusToggled": "Rule {ruleName} status changed",
      "ruleStatusError": "Error changing rule status",
      "confirmDeleteRule": "Delete rule \"{ruleName}\"?",
      "ruleDeleted": "Rule deleted successfully",
      "ruleDeleteError": "Error deleting rule",
      "ruleSaved": "Rule saved successfully",
      "bulkStatusToggled": "Status changed for {count} rules",
      "bulkStatusError": "Error changing rules status",
      "bulkDeleted": "Deleted {count} rules",
      "bulkDeleteError": "Error deleting rules",
      "rulesDeleted": "Rules deleted",
      "rulesActivated": "Rules activated",
      "rulesDeactivated": "Rules deactivated",
      "ruleNotFound": "Rule not found",
      "invalidJsonFormat": "Invalid JSON format",
      "createExpressionFirst": "Create expression first",
      "previewError": "Error during preview",
      "invalidRuleExpression": "Invalid rule expression",
      "ruleNotExecuted": "Rule not executed",
      "loadingRule": "Loading rule...",
      "saving": "Saving...",
      "loading": "Loading...",
      "run": "Run",
      "passed": "Passed",
      "failed": "Failed",
      "success": "Success",
      "errorDuringValidation": "Error during validation",
      "noQcRulesFound": "No QC rules found"
    },
    "form": {
      "ruleName": "Rule Name",
      "ruleNameRequired": "Rule name is required",
      "fieldPath": "Primary Field",
      "fieldPathRequired": "Primary field is required",
      "fieldPathHint": "The main field this rule validates. Other fields can be used in the JSONLogic expression.",
      "errorMessage": "Error Message",
      "errorMessageHint": "Shown to reviewers when a submission fails this rule.",
      "errorMessageRequired": "Error message is required",
      "constraintExpression": "Constraint Expression",
      "constraintExpressionHint": "Use '{'\"var\": \"field_name\"'}' to reference submission fields. Click Apply to validate JSON.",
      "constraintExpressionRequired": "Constraint expression is required",
      "ruleType": "Rule Type",
      "severityLevel": "Severity Level",
      "ruleActive": "Rule is active",
      "ruleActiveHint": "Inactive rules are kept but not applied during validation.",
      "basicSettings": "Basic Settings",
      "jsonLogicBuilder": "JSONLogic builder",
      "jsonLogicBuilderHint": "Define when this rule passes. The expression must evaluate to true for valid submissions.",
      "reset": "Reset",
      "apply": "Apply",
      "saveChanges": "Save Changes",
      "createRule": "Create Rule",
      "editRule": "Edit Rule",
      "rulePreview": "Rule Preview",
      "testRuleOnSample": "Test rule on sample data",
      "detailedResults": "Detailed Results",
      "showSubmissionData": "Show submission data",
      "help": "Help",
      "ruleTypes": "Rule Types",
      "severityLevels": "Severity Levels",
      "requiredField": "Required field",
      "constraintCheck": "Constraint check",
      "calculatedField": "Calculated field",
      "customLogic": "Custom logic",
      "blocksSubmission": "Blocks submission",
      "showsWarning": "Shows warning",
      "informationalMessage": "Informational message",
      "jsonLogicExamplesTitle": "Expression examples",
      "agreementCheckExample": "Agreement check:",
      "finalStatusCheckExample": "Final status check:",
      "enumeratorCheckExample": "Enumerator check:",
      "complexLogicExample": "Complex logic:",
      "fieldValue": "Field value",
      "previewStatsLine": "{passed} passed · {failed} failed · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Search by name, field or message...",
      "ruleType": "Rule type",
      "severityLevel": "Severity level",
      "status": "Status",
      "enterRuleName": "Enter rule name",
      "enterErrorMessage": "Enter error message",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Disable rule",
        "enableRule": "Enable rule"
      }
    },
    "viewModes": {
      "cards": "Cards",
      "table": "Table"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "ODK Data Cleanup Monitor",
      "subtitle": "Monitor automatic cleanup system and view data statistics",
      "selectFormTitle": "Select Form for Cleanup Monitoring",
      "currentProject": "Current Project",
      "searchPlaceholder": "Search and select form...",
      "systemInfo": {
        "title": "Automatic Cleanup System",
        "activeFormsTitle": "Active forms (open/closing)",
        "activeFormsDesc": "Only the 5 most recent folders are automatically kept. Cleanup occurs during every synchronization.",
        "closedFormsTitle": "Closed forms (closed)",
        "closedFormsDesc": "When a form is closed, 4 folders are automatically archived, leaving 1 for statistics.",
        "monitoringTitle": "Monitoring",
        "monitoringDesc": "Select a form above to view statistics and monitor the cleanup system."
      }
    },
    "manager": {
      "title": "ODK Data Cleanup Manager",
      "loading": "Loading cleanup data...",
      "noData": {
        "title": "No Data Available",
        "meaning": "What this means:",
        "noSubmissions": "This form has no submissions yet",
        "noSync": "The form hasn't been synced from ODK Central",
        "noCleanupNeeded": "No cleanup is needed at this time"
      },
      "errorLoading": "Error Loading Data",
      "stats": {
        "title": "Current Statistics",
        "totalFolders": "Total Folders",
        "totalSize": "Total Size",
        "completeData": "Complete Data"
      },
      "formInfo": {
        "title": "Form Information",
        "state": "State:",
        "active": "Active:",
        "lastSubmission": "Last Submission:",
        "lastSync": "Last Sync:",
        "yes": "Yes",
        "no": "No"
      },
      "recommendation": {
        "title": "Cleanup Recommendation",
        "action": "Action:",
        "reason": "Reason:",
        "requiresApproval": "Requires approval for cleanup"
      },
      "buttons": {
        "refresh": "Refresh Stats",
        "dryRun": "Dry Run",
        "cleanupNow": "Cleanup Now",
        "forceCleanup": "Force Cleanup"
      },
      "results": {
        "title": "Last Cleanup Result",
        "strategy": "Strategy:",
        "kept": "Kept: {count} folders",
        "deleted": "Deleted: {count} folders",
        "archived": "Archived: {count} folders",
        "skipped": "Skipped: {count} folders"
      },
      "folders": {
        "title": "Recent Folders ({count})",
        "columns": {
          "name": "Folder Name",
          "created": "Created",
          "size": "Size (MB)",
          "files": "Files"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Global cleanup completed successfully",
      "globalCleanupFailed": "Global cleanup failed",
      "errorLoadingProjects": "Error loading projects",
      "errorLoadingForms": "Error loading forms",
      "noDataOrSync": "This form has no data or has not been synced yet",
      "statsLoadFailed": "Failed to load cleanup statistics",
      "dryRunSuccess": "Dry run completed - no files were deleted",
      "dryRunFailed": "Dry run failed",
      "cleanupNotRecommended": "Cleanup not recommended for this form",
      "cleanupSuccess": "Cleanup completed successfully",
      "cleanupFailed": "Cleanup failed",
      "forceNotAvailable": "Force cleanup not available for this form",
      "forceConfirm": "Are you sure you want to force cleanup? This action cannot be undone.",
      "forceSuccess": "Force cleanup completed successfully",
      "forceFailed": "Force cleanup failed"
    }
  },
  "permissionGroups": {
    "create": "Create Group",
    "delete": "Delete Group",
    "assignToUser": "Assign Group to User",
    "removeFromUser": "Remove Group from User",
    "roleNames": {
      "manager": "Manager",
      "projectMember": "Project member",
      "dataViewer": "Data Viewer",
      "dataCollector": "Data Collector",
      "dataDownloader": "Data Downloader",
      "dataAnalyst": "Data Analyst",
      "qcViewer": "QC Viewer",
      "qcEditor": "QC Editor",
      "monitor": "Monitor",
      "formDesigner": "Form Designer"
    },
    "userManagement": {
      "clientGroups": "Client Groups",
      "clientGroupsDescription": "Groups intended for external or client-facing users.",
      "regularGroups": "Regular Groups",
      "regularGroupsDescription": "Groups intended for internal project members.",
      "errorTitle": "Could not load groups",
      "noProjectsTitle": "Select a project first",
      "noProjectsDescription": "Choose a project before assigning permission groups.",
      "noGroupsTitle": "No groups available",
      "noGroupsAvailable": "No groups available for assignment",
      "errorLoadingGroups": "Error loading groups",
      "selectedGroups": "Selected groups",
      "selectedCount": "{count} selected",
      "selectedPill": "Selected",
      "includedPermissions": "Included permissions",
      "groupDetailsTitle": "Group details",
      "groupDescriptionFallback": "No description provided.",
      "rolesCount": "Roles: {count}",
      "viewGroupDetails": "View roles in {name}"
    }
  },
  "menu": {
    "dashboard": "Dashboard",
    "my-organization": "My Organization",
    "userManagement": "User Management",
    "organizationStats": "Organization Stats",
    "organizationSettings": "Organization Settings",
    "projects": "Projects",
    "odkServers": "ODK Servers",
    "odkSync": "Sync Workbench",
    "payments": "Payments",
    "faq": "Help",
    "help": "Help",
    "preferences": "Account preferences",
    "settings": "Application settings",
    "billing": "Billing"
  },
  "organization": {
    "settingsSubtitle": "Manage organization profile, AI subscription, maps, and connected infrastructure.",
    "profile": {
      "sectionTitle": "Organization profile",
      "name": "Name",
      "description": "Description",
      "edit": "Edit",
      "editTitle": "Edit organization",
      "noDescription": "No description provided",
      "created": "Created",
      "updated": "Last updated",
      "loadError": "Failed to load organization profile"
    },
    "infrastructure": {
      "sectionTitle": "Connected infrastructure",
      "subtitle": "Read-only summary of servers, projects, users, and active forms.",
      "servers": "ODK servers",
      "projects": "Projects",
      "users": "Users",
      "activeForms": "Active forms",
      "defaultServer": "Default ODK server",
      "noDefaultServer": "No default server selected",
      "manageServers": "Manage ODK servers",
      "viewSync": "Open Sync Workbench",
      "loadError": "Failed to load infrastructure summary"
    },
    "quickLinks": {
      "sectionTitle": "Related pages",
      "userManagement": "User management",
      "statistics": "Organization statistics",
      "projects": "Projects",
      "reportTemplates": "Report templates",
      "odkServers": "ODK servers",
      "syncWorkbench": "Sync Workbench"
    }
  },
  "preferences": {
    "title": "Preferences",
    "subtitle": "Review your account profile, organization access, permission groups, and project roles.",
    "accessOverview": "Access overview",
    "organizationOwner": "Organization Owner",
    "organizationOwnerDescription": "You have full access to all organization resources and projects.",
    "permissionGroups": "Permission groups",
    "permissionGroupsDescription": "Project-scoped groups and their roles",
    "perProject": "Per project",
    "noProjectGroups": "No project-specific groups.",
    "projectsAccess": "Projects access",
    "projectsAccessDescription": "Projects you can open and your roles",
    "ownerNoProjects": "As the organization owner, you have full access. Projects will appear once created or imported.",
    "noProjectAccess": "No project access granted yet.",
    "projectIdLabel": "ID: {id}",
    "projectLabelFallback": "Project #{id}",
    "memberSince": "Member since:",
    "userFallback": "User",
    "invalidDate": "Invalid Date",
    "name": "Name",
    "email": "Email",
    "password": "Password",
    "resetPassword": "Reset Password",
    "emailSubscriptions": "Email subscriptions",
    "emailSubscriptionsVisit": "To manage what emails you get, visit the",
    "notificationSettingsLink": "Notification settings",
    "cancelAccount": "Cancel account",
    "cancelAccountDescription": "Permanently delete your organization, users, and all associated data.",
    "cancelAccountAction": "Delete account",
    "editName": "Edit name",
    "editNameSubtitle": "Update the display name shown across the application.",
    "nameRequired": "Name is required",
    "nameMinLength": "Name must be at least 2 characters",
    "nameUpdateFailed": "Failed to update name. Please try again.",
    "nameChangedSuccess": "You've successfully changed your name",
    "resetPasswordTitle": "Reset password",
    "resetPasswordSubtitle": "Enter your current password, then choose a new one.",
    "passwordRequirementsTitle": "Password requirements",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "repeatNewPassword": "Repeat new password",
    "passwordMinLength": "Must be at least 8 characters long",
    "passwordUniqueChars": "Must contain at least 6 unique characters",
    "updatePassword": "Update Password",
    "passwordChangedSuccess": "You've successfully changed your password",
    "passwordUpdateFailed": "Failed to update password. Please try again.",
    "currentPasswordRequired": "Current password field is required",
    "newPasswordRequired": "New password field is required",
    "repeatPasswordRequired": "Repeat new password field is required",
    "passwordMatchUnique": "New password cannot be the same as current password",
    "confirmPasswordMismatch": "Confirm password does not match new password",
    "dangerZoneTitle": "Danger zone",
    "dangerZoneSubtitle": "Irreversible actions that affect your entire organization.",
    "cancelAccountModalTitle": "Delete account",
    "cancelAccountModalSubtitle": "Verify your identity and confirm that you want to permanently delete your account.",
    "cancelAccountConsequenceOrg": "Your organization and all projects will be deleted",
    "cancelAccountConsequenceUsers": "All organization members will lose access",
    "cancelAccountConsequenceOdk": "Linked ODK data may be permanently removed",
    "cancelAccountConsequenceIrreversible": "This action cannot be undone",
    "cancelAccountConfirmEmailLabel": "Type your email address to confirm",
    "cancelAccountConfirmEmailRequired": "Email confirmation is required",
    "cancelAccountConfirmEmailMismatch": "Email does not match your account",
    "cancelAccountAcknowledge": "I understand that this will permanently delete my organization and all associated data",
    "cancelAccountAcknowledgeRequired": "You must confirm that you understand the consequences",
    "cancelAccountDeleteButton": "Delete account permanently",
    "cancelAccountUnavailableTitle": "Account deletion is not available yet",
    "cancelAccountUnavailableMessage": "Your identity was verified. Account deletion is being prepared — please contact your administrator or support to request account closure.",
    "cancelAccountWrongPassword": "Incorrect password. Please try again.",
    "dangerZoneCancelAccount": "Danger zone: Delete account",
    "cancelAccountWarning": "This will permanently delete your account and all associated data, including your organization, users, and linked ODK data.",
    "groupFallback": "Group"
  },
  "faq": {
    "title": "Help",
    "subtitle": "Short guides and answers for common UDACAPI tasks."
  },
  "help": {
    "title": "Help",
    "subtitle": "Short guides and answers for common UDACAPI tasks.",
    "searchPlaceholder": "Search guides and questions…",
    "learnMore": "Learn more",
    "openGuide": "Open",
    "openGuideFormScope": "Open dashboard — then pick a project and form",
    "whenToUse": "When to use",
    "steps": "Steps",
    "comingSoon": "More guides for analysis, monitoring, and organization settings are coming soon.",
    "noResults": "No guides match your search.",
    "featureGuides": {
      "odkServers": {
        "title": "ODK Servers",
        "summary": "Connect your ODK Central (or compatible) server so UDACAPI can sync projects and submissions.",
        "whenToUse": "First-time setup, before sync or import.",
        "steps": [
          "Open ODK Servers in the sidebar.",
          "Add the server URL and credentials.",
          "Run Test connection.",
          "Fix URL, credentials, or network issues before syncing."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "Pull new submissions and refresh form structure from ODK.",
        "whenToUse": "After the server is connected; whenever you expect new field data.",
        "steps": [
          "Open Sync Workbench.",
          "Select server, project, and form.",
          "Review cursor and last sync status.",
          "Start sync and wait for completion.",
          "Open the form — Overview, Export, or QC."
        ]
      },
      "import": {
        "title": "Import projects and forms",
        "summary": "Bring existing ODK projects and forms into your organization.",
        "whenToUse": "Migrating from ODK or onboarding a new server.",
        "steps": [
          "Ensure the ODK server is connected and tested.",
          "From Projects, start Import (organization-owned servers only).",
          "Select a project and import forms.",
          "Open a form and verify Overview and Settings."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "AI workbench to draft, preview, and publish XLSForm changes.",
        "whenToUse": "New surveys or major schema changes.",
        "steps": [
          "Open a project and launch XLSForm Assist.",
          "Describe the survey or upload a questions file.",
          "Review the ODK Web Forms preview.",
          "Confirm publish and wait for the job to finish."
        ]
      },
      "formOverview": {
        "title": "Form Overview",
        "summary": "Snapshot of intake, timeline, map, and AI Q&A for the selected period.",
        "whenToUse": "Daily monitoring; quick questions about live form data.",
        "steps": [
          "Open a form and go to Overview.",
          "Choose period (7 / 30 / all) — shared by AI reports and timeline.",
          "Review timeline and map.",
          "Use AI chat or generate summary reports for the same window."
        ]
      },
      "autoReports": {
        "title": "Auto reports",
        "summary": "Scheduled and on-demand AI reports per form with email delivery.",
        "whenToUse": "Regular stakeholder updates (weekly or monthly).",
        "steps": [
          "Org → Report templates — create or pick a template.",
          "Form → Auto reports — set schedule and recipients.",
          "Use Generate for a manual preview with period.",
          "Use Send to deliver after preview."
        ]
      },
      "qc": {
        "title": "Quality control (QC)",
        "summary": "Validation rules on submissions; AI can suggest a starter pack.",
        "whenToUse": "After first submissions; before trusting exports or analysis.",
        "steps": [
          "Open a form and go to QC.",
          "Create a rule or use AI suggest.",
          "Run validation.",
          "Review flagged submissions."
        ]
      },
      "export": {
        "title": "Data export",
        "summary": "Export submissions to CSV, Excel, and more; large forms use async jobs.",
        "whenToUse": "Handoff to Excel, SPSS, Stata, or external pipelines.",
        "steps": [
          "Open a form and go to Data Export.",
          "Choose format and options.",
          "Start export and wait for the job.",
          "Download the file from the jobs list."
        ]
      }
    },
    "faq": {
      "title": "Frequently asked questions",
      "items": {
        "sync-no-new-data": {
          "question": "Why is sync not pulling new submissions?",
          "answer": "Check that the ODK server is reachable, the sync cursor is not stuck on an old position, you selected the correct form, and your account can access that project. Run Test connection on the server, then retry sync from Sync Workbench."
        },
        "sync-cursor": {
          "question": "What is a sync cursor?",
          "answer": "A cursor is the incremental sync pointer — where UDACAPI last stopped reading submissions. Resetting or misaligned cursors can skip or re-fetch data; use Sync Workbench to inspect cursor status before forcing a full re-sync."
        },
        "import-server-type": {
          "question": "Why can't I import from this server?",
          "answer": "Project import is allowed only on organization-owned ODK servers. Shared and Global servers cannot be used for import — connect an org server or ask your administrator."
        },
        "import-how": {
          "question": "How do I import an existing ODK project?",
          "answer": "Connect and test the server, then go to Projects → Import, pick the project, and import forms. See the Import projects and forms guide above for step-by-step instructions."
        },
        "xlsform-where": {
          "question": "Where is XLSForm Assist?",
          "answer": "Open a project from Projects, then launch XLSForm Assist from the project forms area (or the dedicated assist route for that project)."
        },
        "ai-scope": {
          "question": "What can the form AI answer?",
          "answer": "Questions about the form schema, submissions, analytics, QC rules, and sync status — based on live data for that form. It does not replace QC sign-off or legal review of personal data."
        },
        "ai-quota": {
          "question": "Why do I see quota exceeded?",
          "answer": "Your organization hit an agent usage limit. Wait for the reset window or contact your organization owner or administrator to adjust limits."
        },
        "auto-generate-vs-schedule": {
          "question": "What is the difference between Generate and a scheduled report?",
          "answer": "Generate runs on demand for the period you choose on the form. Scheduled runs follow the template cron and use the schedule-aligned data window — not necessarily the same as the Overview period selector."
        },
        "auto-templates": {
          "question": "Where are report templates managed?",
          "answer": "At organization level: My Organization → Report templates (or the report templates quick link). Templates are org-central; each form's Auto reports tab shows templates that cover that form."
        },
        "qc-first-rule": {
          "question": "How do I create my first QC rule?",
          "answer": "Open the form → QC → Create rule, or use AI suggest to draft a starter pack from the form structure, then run validation."
        },
        "export-slow": {
          "question": "Export is taking a long time — is that normal?",
          "answer": "Yes for large forms. Exports run as background jobs. Keep the page open or return to Data Export to download when the job completes."
        },
        "export-where": {
          "question": "Where is my export file?",
          "answer": "On the form's Data Export tab — in the jobs/history list with a download action when the job status is complete."
        },
        "permissions-missing": {
          "question": "I don't see a project or tab",
          "answer": "Your permission group may not include that project or feature. Ask your organization owner to review permission groups and project access."
        }
      }
    },
    "support": {
      "title": "Need more help?",
      "body": "Contact UDACAPI support if these guides don't resolve your issue.",
      "contactLabel": "Email support"
    }
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Appearance and language for this browser.",
    "appearanceSection": "Appearance",
    "appearanceSectionSubtitle": "Choose light or dark theme for the interface.",
    "themeLabel": "Theme",
    "languageSection": "Language",
    "languageSectionSubtitle": "Interface language. Applies immediately and is saved in this browser."
  },
  "projects": {
    "pageTitle": "Projects",
    "subtitle": "Manage projects, switch between cards and table, and launch import or creation flows.",
    "refresh": "Refresh",
    "createProject": "Create Project",
    "importRestrictions": {
      "message": "La importación de proyectos está permitida solo en servidores que pertenezcan a la organización. Los servidores Shared y Global no pueden ser utilizados para importar proyectos."
    },
    "viewMode": {
      "cards": "Cards",
      "table": "Table"
    },
    "sections": {
      "forms": {
        "title": "Forms of the project"
      },
      "users": {
        "title": "Users of the project"
      },
      "formAccess": {
        "title": "Form Access",
        "description": "Choose which App Users can download each form in ODK Collect.",
        "save": "Save",
        "discard": "Discard",
        "saving": "Saving…",
        "saved": "Form access saved",
        "saveError": "Could not save all changes",
        "loadError": "Could not load form access",
        "emptyForms": "No published forms in this project",
        "emptyAppUsers": "No App Users yet. Create a QR code first.",
        "openQr": "Open QR workbench",
        "openForms": "Open forms",
        "dirtyHint": "Unsaved changes"
      },
      "info": {
        "title": "Project Information",
        "basicInfo": "Basic Information",
        "accessInfo": "Access Information",
        "statistics": "Project Statistics",
        "fields": {
          "projectId": "Project ID",
          "name": "Name",
          "description": "Description",
          "status": "Status",
          "orgId": "Organization ID",
          "odkProjectId": "ODK Project ID",
          "createdAt": "Creation Date",
          "updatedAt": "Last Updated",
          "yourRole": "Your Role",
          "canManageForms": "Can Manage Forms",
          "canViewUsers": "Can View Users",
          "isManager": "Is Manager",
          "isOwner": "Is Owner",
          "totalUsers": "Project Users"
        },
        "status": {
          "active": "Active",
          "archived": "Archived"
        },
        "noDescription": "No description provided",
        "loading": "Loading project information...",
        "loadError": "Failed to load project information",
        "statsLoadError": "Failed to load project statistics",
        "invalidDate": "Invalid date",
        "notAvailable": "N/A"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Add user to project",
        "editTitle": "Edit project access",
        "addSubtitle": "Select a user first, then assign permission groups for this project.",
        "editSubtitle": "Review the selected user and update permission groups for this project.",
        "stepOne": "Step 1",
        "stepTwo": "Step 2",
        "stepReady": "Ready",
        "stepRequired": "Required",
        "stepLocked": "Locked",
        "selectUserTitle": "Select user",
        "selectedUser": "Selected user",
        "selectUserHint": "Choose who should get access to this project.",
        "selectedUserHint": "This user is already assigned to the project. You can update their permission groups below.",
        "selectUserPlaceholder": "Select a user",
        "selectUserHelper": "Owners and superusers are excluded from this list.",
        "permissionGroupsTitle": "Permission groups",
        "permissionGroupsHint": "Choose one or more permission groups for the selected user.",
        "permissionGroupsLockedTitle": "Select a user to continue",
        "permissionGroupsLockedHint": "Permission groups become available after you choose a user.",
        "addToProject": "Add to project",
        "clientUser": "Client user",
        "internalUser": "Internal user"
      },
      "dialogs": {
        "removeUser": {
          "title": "Remove user from project",
          "message": "Do you really want to remove this user from the project?",
          "confirm": "Remove"
        }
      },
      "list": {
        "searchPlaceholder": "Search users",
        "filterByPermissionGroups": "Filter by permission groups",
        "accessDeniedTitle": "Access denied",
        "accessDeniedMessage": "You do not have permission to view the users of this project.",
        "loadErrorTitle": "Could not load project users",
        "emptyTitle": "No users in the project yet",
        "emptyMessage": "Add the first user to start managing project access.",
        "emptyFilteredTitle": "No users match the current filters",
        "emptyFilteredMessage": "Try changing the search text or selected permission groups.",
        "noPermissionGroups": "No permission groups"
      },
      "messages": {
        "saveSuccess": "User access was updated successfully.",
        "removeSuccess": "User was removed from the project."
      },
      "errors": {
        "assignGroupsFailed": "Failed to assign permission groups. Please try again.",
        "assignRoleFailed": "Failed to assign the project role.",
        "loadUsersFailed": "Failed to load project users.",
        "permissionGroupsLoadFailed": "Failed to load permission groups.",
        "projectMemberRoleFailed": "Failed to resolve the project member role.",
        "removeUserFailed": "Failed to remove the user from the project.",
        "rolesLoadFailed": "Failed to load project roles.",
        "saveUserFailed": "Failed to update project access."
      }
    },
    "modal": {
      "addProject": "Add project",
      "editProject": "Edit project",
      "unsavedChanges": "Form has unsaved changes. Are you sure you want to close it?"
    },
    "form": {
      "projectName": {
        "label": "Project Name",
        "placeholder": "Enter project name",
        "required": "Project name is required"
      },
      "odkServer": {
        "label": "ODK Server",
        "placeholder": "Select ODK server",
        "required": "ODK Server is required",
        "noServers": "No available ODK servers. Please add a server first."
      },
      "description": {
        "label": "Description",
        "placeholder": "Optional project description"
      },
      "buttons": {
        "cancel": "Cancel"
      }
    },
    "cards": {
      "noProjects": "No projects",
      "status": {
        "active": "Active",
        "archived": "Archived"
      }
    },
    "confirmations": {
      "odkServerRequired": "Please add at least one ODK server before creating a project.",
      "delete": {
        "imported": {
          "title": "Delete imported project",
          "message": "Are you sure you want to delete project \"{name}\"?\n\nThis project was imported from ODK Central. It will only be deleted from this application's database, but will remain on the ODK Central server.",
          "messageWithStats": "Are you sure you want to delete project \"{name}\"?\n\nThis project contains {formsCount} forms and {submissionsCount} submissions.\nThe project will be archived/hidden (soft-delete), and data will be preserved.\n\nThis project was imported from ODK Central. It will only be deleted from this application's database, but will remain on the ODK Central server."
        },
        "regular": {
          "title": "Delete project",
          "message": "Are you sure you want to delete project \"{name}\"?\n\nWARNING: This will permanently delete the project from both this application's database and the ODK Central server.",
          "messageWithStats": "Are you sure you want to delete project \"{name}\"?\n\nThis project contains {formsCount} forms and {submissionsCount} submissions.\nThe project will be archived/hidden (soft-delete), and data will be preserved."
        },
        "confirmButton": "Delete"
      }
    },
    "notifications": {
      "organizationNotSelected": "Organization not selected"
    },
    "import": {
      "title": "Import ODK Projects",
      "subtitle": "Load available ODK projects from an organization server and import them into this workspace.",
      "selectServer": "Select ODK Server",
      "getProjects": "Get Projects",
      "availableProjects": "Available Projects",
      "noProjectsFound": "No projects found on the selected server.",
      "importProject": "Import",
      "imported": "Imported",
      "errors": {
        "serversLoadFailed": "Failed to load ODK servers. Please try again later.",
        "projectsLoadFailed": "Failed to load projects from ODK server. Please check the connection and try again.",
        "importFailed": "Failed to import project. Please try again later.",
        "importError": "Error importing project: {detail}"
      }
    },
    "importForms": {
      "title": "Import ODK Forms",
      "subtitle": "Select forms from your ODK Central project to add them here.",
      "subtitleWithProject": "Select forms from Central project {odkProjectId} to add them to {name}.",
      "loadingForms": "Loading forms from ODK server...",
      "availableForms": "Available Forms",
      "searchForms": "Search forms...",
      "selectAll": "Select All",
      "deselectAll": "Deselect All",
      "importSelected": "Import Selected",
      "noFormsFound": "No forms found for this project on the ODK server.",
      "errors": {
        "projectNotLinked": "Project is not linked to an ODK server",
        "formsLoadFailed": "Failed to load forms from ODK server. Please try again later.",
        "formsLoadError": "Error loading forms: {detail}",
        "importFailed": "Failed to import forms. Please try again later.",
        "importError": "Import error: {detail}"
      },
      "status": {
        "imported": "Imported",
        "available": "Available"
      },
      "progress": {
        "started": "Import started",
        "completedSummary": "Forms are ready in this project.",
        "failedSummary": "Some forms could not be imported. Review the details below.",
        "viewProject": "View project",
        "forms": "{done} / {total} forms",
        "submissions": "{count} submissions processed",
        "submissionsProgress": "{fetched} / {total} submissions synced",
        "stages": {
          "queued": "Waiting to start",
          "pending": "Waiting to start",
          "importingForms": "Importing forms",
          "syncingData": "Syncing data"
        },
        "messages": {
          "queued": "Job has been queued and is waiting to start...",
          "importingForms": "Importing form metadata..."
        }
      }
    },
    "detail": {
      "loading": "Loading project...",
      "returnToProjects": "Return to projects",
      "forms": {
        "title": "Project forms",
        "noForms": "The project has no forms.",
        "contactAdmin": "Contact the administrator to add forms.",
        "actions": {
          "publish": "Publish",
          "abandon": "Abandon",
          "attachments": "Attachments",
          "qrCode": "QR code for testing",
          "previewEnketo": "Preview in Enketo",
          "downloadTestData": "Download test data",
          "formSettings": "Form settings",
          "viewDetails": "View/Details",
          "changeState": "Change state",
          "delete": "Delete/Abandon"
        },
        "modals": {
          "qrCode": {
            "title": "QR code for testing",
            "description": "Scan the QR code to test the form"
          },
          "formSettings": {
            "title": "Form settings",
            "basicSettings": "Basic settings (Placeholder)",
            "accessSettings": "Access settings (Placeholder)",
            "placeholder": "This is a demonstration interface. Functionality is under development."
          }
        },
        "messages": {
          "tryAgain": "Try again",
          "publishing": "Publishing form {name}...",
          "published": "Form {name} published successfully",
          "previewing": "Previewing {name} in Enketo (dev placeholder)",
          "downloading": "Downloading test data for {name} (dev placeholder)",
          "saving": "Saving settings for {name} (dev placeholder)",
          "missingData": "Missing data to import forms",
          "missingXlsformData": "Missing data to load XLSForm",
          "noAttachments": "The form has no attachments"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Required field",
          "constraint": "Constraint",
          "calculation": "Calculation",
          "custom": "Custom"
        },
        "severity": {
          "error": "Error",
          "warning": "Warning",
          "info": "Info"
        },
        "form": {
          "tabs": {
            "basic": "Basic settings",
            "preview": "Preview"
          },
          "ruleNameLabel": "Rule name *",
          "ruleNamePlaceholder": "Enter rule name",
          "ruleTypeLabel": "Rule type *",
          "severityLabel": "Severity level *",
          "fieldPathLabel": "Field path *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Constraint expression *",
          "calculationFormulaLabel": "Calculation formula *",
          "simpleEditor": "Simple editor",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Apply JSONLogic",
          "errorMessageLabel": "Error message *",
          "errorMessagePlaceholder": "Enter error message",
          "activeLabel": "Rule active",
          "previewTitle": "Rule Preview",
          "runPreview": "Run Preview",
          "previewHint": "Tests rule on sample data",
          "invalidJson": "Invalid JSON format",
          "createExpressionFirst": "Create rule expression first",
          "previewError": "Error executing preview",
          "previewResults": "Preview results ({count} records):",
          "passed": "Passed:",
          "failed": "Failed:",
          "successRate": "Success rate:",
          "validation": {
            "ruleNameRequired": "Rule name is required",
            "fieldPathRequired": "Field path is required",
            "errorMessageRequired": "Error message is required",
            "constraintExpressionRequired": "Constraint expression is required",
            "calculationFormulaRequired": "Calculation formula is required"
          },
          "toasts": {
            "ruleCreated": "Rule created successfully",
            "ruleUpdated": "Rule updated successfully",
            "saveError": "Error saving rule"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "ODK Servers",
    "subtitle": "Manage organization ODK endpoints, defaults, visibility, and connection health.",
    "contextHint": "Connect your ODK server before syncing or importing forms.",
    "addServer": "Add server",
    "editServer": "Edit server",
    "deleteServer": "Delete server",
    "modal": {
      "addSubtitle": "Connect an ODK Central server to this organization.",
      "editSubtitle": "Update connection settings for this server."
    },
    "table": {
      "default": "Default",
      "visibility": "Visibility",
      "setAsDefault": "Set as default",
      "setAsDefaultTooltip": "Set as default server for this organization",
      "testConnection": "Test connection",
      "testConnectionTooltip": "Test connection to ODK Central server",
      "testConnectionDisabled": "Connection testing is available only for servers belonging to the organization",
      "editServer": "Edit server",
      "editServerTooltip": "Edit server details (only for ORGANIZATION servers and with permissions)",
      "deleteServer": "Delete server",
      "deleteServerTooltip": "Delete server (only for ORGANIZATION servers and with permissions)",
      "odkSession": "ODK session"
    },
    "session": {
      "banner": "One or more servers have an expiring or invalid ODK Central session, or no stored password. Edit the server and save the password so the app can reconnect automatically.",
      "ok": "Session OK",
      "expiresSoon": "Expires soon",
      "expired": "Expired",
      "unknown": "Unknown",
      "noStoredPassword": "No stored password"
    },
    "form": {
      "serverName": "Server name",
      "serverUrl": "Server URL",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Username",
      "password": "Password",
      "passwordPlaceholderEdit": "Leave empty to not change",
      "description": "Description",
      "serverIsActive": "Server is active",
      "serverIsActiveHint": "Inactive servers stay in the list but are not offered when creating projects."
    },
    "validation": {
      "serverNameRequired": "Server name is required",
      "serverUrlRequired": "Server URL is required",
      "urlFormatInvalid": "URL must start with http:// or https://",
      "usernameRequired": "Username is required",
      "passwordRequired": "Password is required"
    },
    "messages": {
      "selectOrganizationFirst": "Please select or create an organization first",
      "loadingServers": "Loading servers...",
      "noServersFound": "No ODK servers found for this organization",
      "failedToLoadServers": "Failed to load servers",
      "noServers": "No ODK servers",
      "serverSaved": "Server \"{name}\" {action} successfully!",
      "serverSetAsDefault": "Server \"{name}\" set as default",
      "connectionTestSuccess": "Connection OK. Projects found: {count}",
      "connectionTestFailed": "Connection test failed"
    }
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications"
  },
  "language": {
    "label": "Language",
    "english": "English",
    "spanish": "Spanish",
    "french": "French",
    "swahili": "Swahili",
    "portuguese": "Portuguese",
    "ukrainian": "Ukrainian",
    "russian": "Russian",
    "turkish": "Turkish"
  },
  "auth": {
    "createAccount": "Create account",
    "dontHaveAccount": "Don't have an account?",
    "email": "Email",
    "emailInvalid": "Email should be valid",
    "emailRequired": "Email field is required",
    "enterEmail": "Enter your email",
    "enterVerificationCode": "Please enter the verification code",
    "forgotPassword": "Forgot password?",
    "forgotPasswordDescription": "If you've forgotten your password, don't worry. Simply enter your email address below, and we'll send you an email with instructions to reset your password. Restoring access to your account has never been easier.",
    "fullName": "Full Name",
    "fullNameRequired": "Full Name field is required",
    "goBack": "Go back",
    "haveAccount": "Have an account?",
    "login": "Login",
    "password": "Password",
    "passwordMustContainLetter": "Password must contain at least one letter",
    "passwordMustContainNumber": "Password must contain at least one number",
    "passwordMustContainSpecial": "Password must contain at least one special character",
    "passwordMustBe8Chars": "Password must be at least 8 characters long",
    "passwordRequired": "Password field is required",
    "passwordRequirements": "Password should be 8+ characters: letters, numbers, and special characters.",
    "passwordsDontMatch": "Passwords don't match",
    "registrationFailed": "Registration failed. Please try again.",
    "registrationSuccess": "You've successfully signed up! Please check your email for activation instructions.",
    "repeatPassword": "Repeat Password",
    "repeatPasswordRequired": "Repeat Password field is required",
    "resetInstructionsSent": "Password reset instructions sent to your email.",
    "resetInstructionsFailed": "Failed to send password reset email. Please try again.",
    "resetPassword": "Reset password",
    "sendResetInstructions": "Send reset instructions",
    "signUp": "Sign Up",
    "twoFactorAuthentication": "Two-Factor Authentication",
    "verificationCode": "Verification Code",
    "verificationCodeRequired": "Verification code is required",
    "verifyCode": "Verify Code"
  },
  "dashboard": {
    "subtitle": "Monitor active forms across organization projects and switch between card and table views.",
    "activeFormsTitle": "Active Forms",
    "activeFormsSubtitle": "Open and closing forms from all organization projects.",
    "noActiveForms": "No active forms"
  },
  "qr": {
    "title": "QR Code (ODK Collect Settings)",
    "titleShort": "QR Code",
    "qrName": "QR code name",
    "projectSection": "Project",
    "projectName": "Project name",
    "projectIcon": "Project icon",
    "projectColor": "Project color",
    "generalSection": "General settings",
    "serverUrl": "Server URL",
    "username": "Username",
    "password": "Password",
    "adminSection": "Admin settings",
    "admin": {
      "edit_saved": "Edit saved",
      "send_finalized": "Send finalized",
      "view_sent": "View sent",
      "password": "Admin password",
      "advanced": "Advanced admin",
      "getBlank": "Get blank",
      "deleteSaved": "Delete saved",
      "qrCodeScanner": "QR code scanner",
      "changeServer": "Change server",
      "changeAppTheme": "Change app theme",
      "changeAppLanguage": "Change app language",
      "changeFontSize": "Change font size",
      "changeNavigation": "Change navigation",
      "maps": "Maps",
      "periodicUpdates": "Periodic updates",
      "automaticUpdate": "Automatic update",
      "hideOldVersions": "Hide old versions",
      "changeAutosend": "Change autosend",
      "deleteAfterSend": "Delete after send",
      "defaultToFinalized": "Default to finalized",
      "changeConstraintBehavior": "Change constraint behavior",
      "highResolution": "High resolution",
      "imageSize": "Image size",
      "guidanceHint": "Guidance hint",
      "externalAppRecording": "External app recording",
      "instanceFormSync": "Instance form sync",
      "changeFormMetadata": "Change form metadata",
      "analytics": "Analytics",
      "movingBackwards": "Moving backwards",
      "accessSettings": "Access settings",
      "changeLanguage": "Change language",
      "jumpTo": "Jump to",
      "saveMid": "Save mid",
      "saveAs": "Save as",
      "markAsFinalized": "Mark as finalized"
    },
    "general": {
      "theme": "Theme",
      "language": "Language",
      "fontSize": "Font size",
      "navigation": "Navigation",
      "constraintBehavior": "Constraint behavior",
      "advanced": "Advanced general",
      "formlistUrl": "Formlist URL",
      "submissionUrl": "Submission URL",
      "periodicUpdates": "Periodic updates",
      "deleteAfterSend": "Delete after send",
      "defaultCompleted": "Default completed",
      "externalAppRecording": "External app recording"
    },
    "formManagement": {
      "title": "Form management",
      "updateMode": "Update mode",
      "autosend": "Autosend",
      "imageSize": "Image size",
      "automaticUpdate": "Automatic update",
      "hideOldVersions": "Hide old versions",
      "instanceSync": "Instance sync",
      "guidanceHint": "Guidance hint",
      "highResolution": "High resolution"
    },
    "maps": {
      "title": "Maps",
      "basemap": "Basemap",
      "googleStyle": "Google style",
      "mapboxStyle": "Mapbox style",
      "usgsStyle": "USGS style",
      "cartoStyle": "CARTO style",
      "referenceLayer": "Reference layer (path)"
    },
    "identity": {
      "title": "Identity",
      "analytics": "Analytics",
      "userName": "User name",
      "email": "Email",
      "phone": "Phone"
    },
    "presets": {
      "title": "QR Presets",
      "save": "Save Preset",
      "load": "Load preset...",
      "delete": "Delete",
      "defaultName": "Preset {number}"
    },
    "preview": {
      "title": "JSON Preview",
      "reset": "Reset",
      "import": "Import"
    },
    "history": {
      "title": "Generated QR Codes",
      "viewAll": "View All",
      "view": "View",
      "download": "Download",
      "copy": "Copy",
      "delete": "Delete",
      "more": "... and {count} more"
    },
    "actions": {
      "generate": "Generate QR",
      "downloadPng": "Download PNG",
      "copyBase64": "Copy Base64",
      "reset": "Reset",
      "importJson": "Import JSON"
    },
    "placeholders": {
      "qrName": "My device QR",
      "projectName": "Field team",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "icon": "📋",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles"
    },
    "options": {
      "default": "Default",
      "system": "System"
    },
    "workbench": {
      "contextHint": "Create an ODK Collect QR with an App User token baked into the server URL.",
      "serverReady": "Server set",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: not linked — check project ODK server",
      "essentialsTitle": "Configure",
      "essentialsDesc": "Name the QR and Collect project card, pick an icon and color, then generate.",
      "nameHint": "Also used as the App User display name in ODK Central.",
      "projectNameHint": "Label shown in ODK Collect for this configuration (not the udacapi project name).",
      "iconHint": "Shown on the Collect project card. Default is fine for most teams.",
      "changeIcon": "Change icon",
      "iconDialogTitle": "Collect project icon",
      "iconDialogSubtitle": "Choose one glyph for the project card on the device.",
      "applyIcon": "Use icon",
      "serverHint": "Taken from the project's linked ODK server. Generate injects /v1/key/{token}/projects/{id}.",
      "advancedTitle": "Advanced Collect options",
      "advancedHint": "Theme, form sync, maps — optional",
      "previewTitle": "Preview",
      "previewDesc": "Scan with ODK Collect after generate.",
      "libraryHint": "Stored in this browser for this project.",
      "libraryEmpty": "No QR codes yet. Generate one to start the library.",
      "libraryCount": "{count} in library"
    },
    "formAccess": {
      "title": "Forms this collector can access",
      "hint": "Select at least one published form. Without this, Collect shows an empty form list.",
      "selectAll": "Select all",
      "clear": "Clear",
      "required": "Select at least one form",
      "assignFailed": "Could not assign forms to the App User",
      "manageAll": "Manage all form access",
      "formsCount": "{n} forms",
      "noPublishedForms": "No published forms in this project yet."
    },
    "messages": {
      "nameRequiredForPreset": "Please enter a name for the preset",
      "nameRequiredForAppUser": "QR Code name is required for App User creation",
      "projectNameRequired": "Project name is required",
      "serverRequired": "Server URL is required",
      "missingOdkProject": "This project has no ODK Central project id. Re-import or check project settings.",
      "invalidSettings": "Invalid settings",
      "generateSuccess": "QR generated and App User created",
      "generateError": "Failed to generate QR and create App User",
      "presetSaved": "Preset saved",
      "base64Copied": "Base64 copied",
      "jsonImported": "Settings imported from JSON",
      "invalidJsonStructure": "Invalid JSON structure. Must contain project, general, and admin sections.",
      "invalidJsonFormat": "Invalid JSON format",
      "copyBase64Error": "Failed to copy Base64"
    },
    "placeholder": "Generate a QR code to see it here",
    "note": "The code contains zlib-compressed Base64 of JSON with general/admin/project settings. App User auth lives in server_url."
  },
  "forms": {
    "state": {
      "open": "Open",
      "closing": "Closing",
      "closed": "Closed",
      "draft": "Draft"
    },
    "deleteConfirm": {
      "title": "Delete form",
      "subtitle": "Review the consequences before permanently deleting this form.",
      "message": "This cannot be undone.",
      "xmlFormId": "XML ID: {id}",
      "confirm": "Delete permanently",
      "importedWarning": "This form was imported from ODK Central. It will be removed from this application only and will remain on the ODK Central server.",
      "regularWarning": "This action moves the form to the ODK Central trash and marks it as deleted locally.",
      "consequenceDataLoss": "All submissions and export history for this form will be removed from this application.",
      "irreversible": "This action cannot be undone through the interface.",
      "success": "Form {name} was deleted.",
      "successImported": "Form {name} was removed from the application database only.",
      "error": "Failed to delete form: {error}"
    },
    "uploadXlsform": {
      "title": "Upload XLSForm",
      "subtitle": "Upload a .xlsx or .xls workbook (up to 50 MB).",
      "selectFile": "Workbook file",
      "dropFileTitle": "Drop your XLSForm workbook here",
      "supportedFormats": ".xlsx or .xls, up to 50 MB.",
      "replaceFileHint": "Choose another file to replace the current selection.",
      "chooseFile": "Browse files",
      "selectedFile": "Selected file:",
      "formSettings": "Form identifier",
      "uploadOptions": "Upload options",
      "formId": "Form ID",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "Optional fallback ID. ODK reads the real ID from the settings sheet.",
      "formIdWarning": {
        "title": "Important!",
        "message": "The final form ID will be taken from the 'settings' sheet of the XLSForm file. The ID entered here is used only as a fallback option."
      },
      "updateExisting": "Update existing form",
      "updateExistingHint": "If a form with this ID already exists, it will be updated",
      "ignoreWarnings": "Ignore warnings",
      "ignoreWarningsHint": "Ignore warnings during conversion",
      "publishImmediately": "Publish form immediately",
      "publishImmediatelyHint": "Publish the form immediately",
      "uploadButton": "Upload XLSForm",
      "uploading": "Uploading...",
      "noFileSelected": "Please select a file to upload",
      "noFormId": "Please enter the form ID",
      "uploadingMessage": "Uploading XLSForm \"{formId}\"...",
      "successMessage": "XLSForm \"{formId}\" uploaded successfully!",
      "errorMessage": "Error uploading: {error}",
      "errorFallback": "Upload failed. Please try again.",
      "listUpdated": "XLSForm uploaded successfully! List updated."
    },
    "formDetail": {
      "loading": "Loading form...",
      "formLabel": "Form",
      "returnToProjects": "Return to projects list",
      "sectionShell": {
        "unknownForm": "Unknown form",
        "loading": "Loading...",
        "retry": "Retry",
        "comingSoonTitle": "Coming soon",
        "comingSoonDescription": "This feature is under development. Use other form tools in the meantime."
      },
      "sections": {
        "dashboard": {
          "title": "Form Overview",
          "description": "Statistics and information about the form and collected data"
        },
        "autoReports": {
          "title": "Auto reports",
          "description": "Scheduled and on-demand AI reports that cover this form",
          "contextHint": "Schedule, delivery, and on-demand run for templates that cover this form",
          "manageTemplates": "Manage templates",
          "analysisWindow": "Analysis window",
          "empty": "No auto reports cover this form",
          "emptyHint": "Owners can seed defaults or assign forms in Manage templates",
          "seed": "Seed defaults",
          "loadError": "Could not load auto reports",
          "scope": {
            "all": "All forms",
            "this": "This form",
            "many": "{count} forms"
          },
          "delivery": {
            "email": "Email · {count} recipients",
            "inApp": "In-app only"
          },
          "manualOnly": "Manual only",
          "lastRun": "Last run",
          "noLastRun": "No runs yet",
          "generate": "Generate",
          "generateNow": "Generate",
          "viewLatest": "View latest",
          "generating": "Generating report…",
          "started": "Report started",
          "ribbonManual": "No schedule · {timezone}",
          "sendToRecipients": "Send to {n} recipients",
          "sent": "Sent",
          "sentToast": "Sent to {n} recipients",
          "sendFailed": "Could not send report",
          "noRecipientsHint": "Add recipients in Manage templates to email this report"
        },
        "qc": {
          "title": "Quality Control",
          "description": "Monitor and validate data quality using QC rules",
          "workbench": {
            "contextHint": "Define rules, validate submissions, and review flagged issues for this form.",
            "rulesCount": "{count} rules",
            "activeCount": "{count} active",
            "validationsCount": "{count} validations",
            "summaryTitle": "Rule overview",
            "selectedCount": "{count} selected",
            "createRuleHint": "Define a new validation rule for this form",
            "editRuleHint": "Update rule settings and expression",
            "backToRules": "Back to rules",
            "pipeline": {
              "ariaLabel": "QC validation workflow",
              "define": "Define rules",
              "defineHint": "{count} rules configured",
              "defineEmpty": "No rules yet — create your first check",
              "validate": "Validate data",
              "validateHint": "{count} submissions checked",
              "validateEmpty": "Run validation on incoming submissions",
              "review": "Review issues",
              "reviewHint": "{count} open issues",
              "reviewClear": "No unresolved issues"
            }
          }
        },
        "dataExport": {
          "title": "Data Export",
          "description": "Export form data in various formats"
        },
        "odkExport": {
          "title": "Data Export",
          "description": "Export form data in various formats for analysis",
          "unknownForm": "Unknown Form",
          "exportsCount": "{count} exports",
          "loadingOptions": "Loading export options...",
          "retry": "Retry",
          "infoSubtitleDetailed": "Select export formats and configure options to download your form data.",
          "formatsAvailable": "{count} formats available",
          "formatsTitle": "Export Formats",
          "selectFormats": "Select one or more formats to export",
          "statisticalFormatsTitle": "Statistical Formats",
          "geoFormatsTitle": "Geographic Formats",
          "noGeoData": "No geographic data found in this form",
          "configTitle": "Export Configuration",
          "configSubtitle": "Configure export options and filters",
          "dataOptions": "Data Options",
          "includeRepeats": "Include repeat groups",
          "includeLabels": "Include field labels",
          "includeMetadata": "Include metadata",
          "labelLanguage": "Label Language",
          "selectLanguage": "Select language",
          "loadingLanguages": "Loading languages...",
          "generatingLabels": "Generating labels...",
          "noLabelsAvailable": "No labels available. Click refresh to generate labels.",
          "filters": "Filters",
          "dateRange": "Date Range",
          "startDate": "Start Date",
          "endDate": "End Date",
          "dataFilter": "Data Filter",
          "dataFilterPlaceholder": "e.g., age > 18",
          "readyToExport": "Ready to Export",
          "readyToExportSubtitle": "Click the button to start the export process",
          "labelsRequiredNotice": "Labels are required but not available. Please generate labels first.",
          "activeExports": "Active Exports",
          "exportButton": "Export Data",
          "historyTitle": "Export History",
          "historySubtitle": "View and download previous exports",
          "refresh": "Refresh",
          "loadingHistory": "Loading history...",
          "noHistory": "No exports yet",
          "noHistoryDesc": "Start by exporting data in your preferred format.",
          "workbench": {
            "contextHint": "Choose formats and options, then run export.",
            "geoAvailable": "Geo data",
            "geoUnavailable": "No geo data",
            "optionsTitle": "Options",
            "refreshLabels": "Refresh labels",
            "labelsGenerated": "Labels generated ({count} languages)",
            "exportButtonOne": "Export 1 format",
            "exportButtonMany": "Export {count} formats",
            "selectFormatHint": "Select at least one format to export.",
            "readySummaryOne": "1 format ready to export.",
            "readySummaryMany": "{count} formats ready to export.",
            "jobsTitle": "Jobs",
            "jobsSubtitle": "Track active exports and download previous files.",
            "noActiveJobs": "No exports running.",
            "noHistoryAction": "Pick a format above and run export.",
            "pipeline": {
              "sync": "Sync data",
              "convert": "Convert",
              "ready": "Ready"
            }
          },
          "date": "Date",
          "format": "Format",
          "records": "Records",
          "size": "Size",
          "user": "User",
          "actions": "Actions",
          "download": "Download",
          "viewError": "View Error",
          "errorDetails": "Error Details",
          "errorSubtitle": "Export error information",
          "close": "Close",
          "deleteTitle": "Delete Export",
          "deleteSubtitle": "This action cannot be undone",
          "deleteConfirm": "Are you sure you want to delete the export from {date}? This action cannot be undone.",
          "cancel": "Cancel",
          "delete": "Delete",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "All data",
            "last30": "Last 30 days",
            "last90": "Last 90 days",
            "thisyear": "This year",
            "lastyear": "Last year",
            "custom": "Custom range"
          },
          "status": {
            "odataSyncError": "OData sync check error: {error}",
            "localDataMissing": "Local data missing, downloading OData...",
            "odataStatusError": "OData status error",
            "downloadingOdata": "Downloading OData...",
            "downloadSuccessCount": "Downloaded {count} submissions",
            "downloadError": "OData download error: {error}",
            "geoRequired": "{format} requires geographic data"
          },
          "notifications": {
            "selectFormat": "Please select at least one format",
            "startingDownload": "Starting download...",
            "downloadSuccess": "File downloaded successfully",
            "downloadError": "Download error: {error}",
            "taskIdMissing": "Cannot download: task ID missing",
            "exportDeleted": "Export deleted successfully",
            "exportCompleted": "Export {format} completed",
            "exportFailed": "Export {format} failed",
            "trackingError": "Tracking error: {error}",
            "noErrorDetails": "No error details available",
            "currentUser": "Current User"
          }
        },
        "dataAnalysis": {
          "title": "Data Analysis",
          "description": "Build pivot tables for ad-hoc analysis and save views to monitoring",
          "recordsLoaded": "{count} records loaded",
          "variablesSelected": "{count} variables selected",
          "tablesAvailable": "{count} tables available",
          "workbench": {
            "contextHint": "Select variables, explore with a pivot table, then save a view to monitoring",
            "loadingData": "Loading data...",
            "pipeline": {
              "ariaLabel": "Analysis workflow",
              "source": "Data source",
              "sourceHint": "{table}",
              "sourceEmpty": "Choose a data table",
              "variables": "Variables",
              "variablesHint": "{count} selected",
              "variablesEmpty": "Pick fields to analyze",
              "pivot": "Pivot table",
              "pivotHint": "{count} records loaded",
              "pivotEmpty": "Load data to explore",
              "pivotLoading": "Loading records...",
              "save": "Save view",
              "saveHint": "Ready to save to monitoring",
              "saveEmpty": "Configure pivot first"
            },
            "source": {
              "title": "Data source",
              "subtitle": "Choose which submission table and how values are displayed",
              "labelsMissing": "Labels are not generated for this form",
              "labelsMissingHint": "Generate labels from the XLSForm to show variable names and value labels.",
              "generateLabels": "Generate labels",
              "table": "Data table",
              "tablePlaceholder": "Choose a data table",
              "displayOptions": "Display options",
              "showLabels": "Show labels",
              "language": "Language",
              "includeMetadata": "Include metadata"
            },
            "variables": {
              "title": "Variables",
              "selectedCount": "{count} selected",
              "selectTableFirst": "Select a data table to see available variables.",
              "selectAll": "Select all",
              "clearAll": "Clear all",
              "searchPlaceholder": "Search variables...",
              "empty": "No variables match your search",
              "moreCount": "+{count} more",
              "loading": "Loading...",
              "loadCta": "Load {count} variables"
            },
            "pivot": {
              "title": "Pivot table",
              "subtitle": "Drag fields to rows, columns, or values to build your view",
              "hint": "Drag variables to rows, columns, or values. When the layout looks right, save it as a monitoring table.",
              "reprocess": "Reprocess analytics",
              "saveCta": "Save to monitoring",
              "analyticsProcessed": "{percent}% processed"
            },
            "empty": {
              "title": "Select variables",
              "hint": "Choose one or more variables from the selected table to start your analysis."
            },
            "save": {
              "title": "Save monitoring table",
              "subtitle": "Give this pivot view a name so you can find it on the monitoring page.",
              "tableName": "Table name",
              "tableNamePlaceholder": "Enter table name",
              "description": "Description",
              "descriptionPlaceholder": "What does this table track?",
              "summary": "Analysis summary",
              "variables": "Variables",
              "table": "Table",
              "cancel": "Cancel",
              "confirm": "Save table"
            },
            "toasts": {
              "labelsGenerated": "Labels generated. Reloading variables...",
              "labelsFailed": "Could not generate labels. Check that the XLSForm is available.",
              "saveSuccess": "Table saved. Open Data Monitoring to view it.",
              "saveFailed": "Could not save the table. Try again or contact support.",
              "formIdMissing": "Form ID not found",
              "reprocessSuccess": "Analytics reprocessed: {count} new records",
              "reprocessFailed": "Analytics reprocessing failed",
              "reprocessError": "Analytics reprocessing error: {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Data Monitoring",
          "description": "View saved monitoring tables with real-time updates",
          "tablesCount": "{count} tables",
          "updating": "Updating...",
          "workbench": {
            "contextHint": "Saved pivot views with live data refresh while this page is open",
            "activeViewsCount": "{count} active",
            "liveStrip": {
              "ariaLabel": "Monitoring status",
              "saved": "Saved tables",
              "savedHint": "{count} tables ready",
              "savedEmpty": "No tables saved yet",
              "watch": "Active view",
              "watchHint": "Viewing {title}",
              "watchEmpty": "Select a table to view",
              "watchDisabled": "Create a table first",
              "sync": "Live sync",
              "syncHint": "Updates every 30 seconds",
              "syncActive": "Refreshing now..."
            },
            "displayOptions": {
              "title": "Display options",
              "subtitle": "Control how variable names appear in pivot tables",
              "showLabels": "Show labels",
              "language": "Language"
            },
            "summary": {
              "title": "At a glance",
              "tables": "Saved tables",
              "activeView": "Active view",
              "records": "Records in view",
              "refreshInterval": "Auto refresh"
            },
            "tables": {
              "title": "Monitoring tables",
              "subtitle": "Saved pivot views from data analysis",
              "loading": "Loading monitoring tables...",
              "emptyTitle": "No monitoring tables yet",
              "emptyHint": "Create a pivot table on the analysis page and save it here.",
              "createCta": "Go to analysis",
              "realtimeHint": "Data refreshes every 30 seconds while this page is open. Use Refresh for an immediate update.",
              "records": "{count} records",
              "lastUpdated": "Last updated {time}",
              "view": "View",
              "hide": "Hide",
              "loadingPivot": "Loading pivot data...",
              "public": "Public",
              "private": "Private"
            },
            "delete": {
              "title": "Delete table",
              "confirm": "Delete table \"{title}\"?",
              "detail": "This permanently removes the table and its cached data.",
              "cancel": "Cancel",
              "confirmBtn": "Delete table"
            }
          }
        },
        "settings": {
          "title": "Settings",
          "description": "Form settings management",
          "saveStatus": "Save status",
          "formStatus": "Form Status",
          "basicSettings": "Basic Settings",
          "workbench": {
            "contextHint": "Configure lifecycle, public access, field assets, and maintenance for this form.",
            "basicHint": "Control whether the form accepts new submissions and review published versions.",
            "badges": {
              "version": "Version {version}",
              "publicOn": "Public link on",
              "publicOff": "No public link"
            },
            "lifecycle": {
              "ariaLabel": "Form configuration status",
              "publication": "Publication",
              "published": "Published {date}",
              "publishedNoDate": "Published",
              "draft": "Draft — not published yet",
              "collection": "Collection",
              "collectionOpen": "Accepting submissions",
              "collectionClosing": "Closing — finishing in progress",
              "collectionClosed": "Closed — no new submissions",
              "collectionDraft": "Unavailable until published",
              "access": "Web access",
              "publicActive": "Public link enabled",
              "publicInactive": "No public link configured"
            }
          },
          "notifications": {
            "noChanges": "No changes to save",
            "draftWarning": "Draft forms cannot be changed through this interface. Please publish the form first.",
            "stateChangeHint": "Changing the form status affects whether new submissions are accepted.",
            "invalidState": "Invalid form state: {state}",
            "success": "Form status successfully changed to {state}",
            "error": "Error changing form status: {error}",
            "errorLog": "Error changing form status"
          },
          "version": {
            "title": "Version",
            "notSpecified": "Not specified",
            "history": "Version History",
            "noHistory": "No version history available",
            "download": "Download",
            "restore": "Restore",
            "uploadNew": "Upload New Version",
            "author": "Author",
            "loadError": "Could not load versions: {error}",
            "downloadSuccess": "Version downloaded",
            "downloadError": "Could not download version: {error}",
            "uploadSuccess": "New version uploaded"
          },
          "dataCollectors": {
            "title": "Data Collectors",
            "description": "Manage user access to form data collection",
            "noCollectors": "No assigned data collectors",
            "addCollector": "Add Collector",
            "editCollector": "Edit Collector",
            "removeCollector": "Remove Collector",
            "addCollectorModal": {
              "title": "Add Data Collector",
              "placeholder": "Stub: form for adding data collector will be here"
            }
          },
          "publicAccess": {
            "title": "Public Access",
            "description": "Create a public link for data collection through web interface",
            "publicLink": "Public Link",
            "disable": "Disable",
            "requireAuth": "Require authentication",
            "collectEmail": "Collect email",
            "limitSubmissions": "Limit number of responses",
            "maxSubmissions": "Maximum number of responses",
            "updateSettings": "Update Settings",
            "createLink": "Create Public Link",
            "notCreated": "Public link not created. Create a link for data collection through web interface.",
            "created": "Public link created",
            "copied": "Link copied to clipboard",
            "disabled": "Public link disabled",
            "updated": "Public link settings updated"
          },
          "webAccess": {
            "title": "Web form",
            "description": "Public Enketo link from ODK Central (includes access token; no Central sign-in required).",
            "linkLabel": "Public access link",
            "open": "Open",
            "copied": "Link copied to clipboard",
            "copyError": "Could not copy link",
            "enketoIdOnly": "Enketo ID: {id}. Configure an ODK server URL in this organization to build a full link.",
            "notAvailable": "No active public access link on ODK Central for this form. Create one in Central (Form → Public Access), then refresh this page."
          },
          "qrCodes": {
            "title": "QR codes for data collection",
            "description": "Create and manage Collect app QR codes on the project page.",
            "assignedTitle": "Assigned QR Codes",
            "availableTitle": "Available Project QR Codes",
            "createNew": "Create New QR Code",
            "noAvailable": "No available QR codes",
            "createInstruction": "Create a QR code for configuring data collection devices",
            "manageOnProject": "QR codes for ODK Collect are managed at the project level (App Users).",
            "openProjectQr": "Open project QR codes",
            "openFormAccess": "Manage form access",
            "notifications": {
              "assigned": "QR code assigned to the form",
              "unassigned": "QR code unassigned from the form",
              "copied": "Base64 copied to clipboard",
              "copyError": "Copy error: {error}"
            }
          },
          "attachments": {
            "title": "Attachments and Media Files",
            "description": "Manage files and attachments associated with the form",
            "xlsformFile": "XLSForm File",
            "xlsformDescription": "Download the original XLSForm file for this form in Excel format",
            "downloadXlsform": "Download XLSForm",
            "manageAttachments": "Manage Attachments",
            "downloadSuccess": "XLSForm file downloaded successfully",
            "downloadError": "Error downloading XLSForm file",
            "fileNotFound": "XLSForm file not found for this form",
            "accessDenied": "No access to download XLSForm file",
            "serverError": "Server error: {status}"
          },
          "analytics": {
            "title": "Analytics Management",
            "recreateAnalytics": "Force Recreate Analytics",
            "description": "Recreate analytics data for all form submissions. Use this when analytics data is corrupted or missing.",
            "warning": "This operation will delete all existing analytics and recreate them from raw submission data.",
            "confirmTitle": "Confirm Analytics Recreation",
            "alertTitle": "Warning: Data Recreation Required",
            "alertDescription": "This action will permanently delete all existing analytics data and recreate it from scratch.",
            "whatWillHappen": "What will happen:",
            "step1": "All existing analytics data will be deleted",
            "step2": "Raw submission data will be reprocessed",
            "step3": "New analytics data will be created with correct formatting",
            "step4": "Pivot tables and analysis features will work properly",
            "timeWarning": "This operation may take several minutes for forms with many submissions.",
            "recreateButton": "Force Recreate Analytics",
            "confirmButton": "Yes, Recreate Analytics",
            "success": "Analytics recreated successfully! Processed {processed} submissions, recreated {recreated} analytics records out of {total} total submissions.",
            "error": "Failed to recreate analytics data",
            "apiError": "API Error: {error}",
            "missingFormId": "Local form ID is missing"
          },
          "dangerZone": {
            "title": "Danger Zone",
            "deleteForm": "Delete Form",
            "description": "This action cannot be undone. All collected data will be lost.",
            "confirmDelete": "Confirm Form Deletion",
            "confirmMessage": "Are you sure you want to delete the form \"{name}\"?",
            "confirmDescription": "This action cannot be undone. All collected data will be lost.",
            "enterFormName": "Enter form name for confirmation",
            "deleteFormButton": "Delete Form",
            "formDeleted": "Form deleted (stub function)"
          }
        },
        "datasets": {
          "title": "Datasets",
          "description": "Dataset and entity management"
        }
      },
      "errors": {
        "missingParams": "Missing required parameters for loading form",
        "loadError": "Error loading form data",
        "unknownError": "Unknown error"
      }
    },
    "dashboard": {
      "loading": "Loading analytics...",
      "analyticsError": "Error loading analytics",
      "retry": "Retry loading",
      "workbench": {
        "contextHint": "Form identity, intake, timeline, and AI for one shared period (7 / 30 / all).",
        "completionBadge": "{rate}% completion",
        "metaVersion": "v{version}",
        "metaPublished": "pub {date}",
        "metaUpdated": "upd {date}",
        "summaryTitle": "Collection summary",
        "sections": {
          "metadata": {
            "title": "Form identity",
            "xmlFormId": "XML form ID",
            "version": "Version",
            "published": "Published",
            "updated": "Last updated"
          },
          "intake": {
            "title": "Collection summary",
            "subtitle": "Submission intake across today, this week, and all time"
          },
          "quickLinks": {
            "title": "Quick links"
          },
          "agent": {
            "title": "AI assistant",
            "subtitle": "Generate summaries, analytical reports, or chat about this form"
          },
          "timeline": {
            "title": "Submission timeline",
            "subtitle": "Daily submission volume over the selected period"
          },
          "map": {
            "title": "Geographic distribution",
            "subtitle": "Submission locations with geo data"
          }
        },
        "metrics": {
          "noChange": "No change"
        },
        "intakeStrip": {
          "ariaLabel": "Data collection intake status",
          "today": "Today",
          "todayDelta": "{delta} vs yesterday",
          "todayFlat": "Same as yesterday",
          "week": "This week",
          "weekDelta": "{delta} vs last week",
          "weekFlat": "Same as last week",
          "total": "All responses",
          "totalHint": "Total collected for this form",
          "totalEmpty": "No responses yet"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Total Submissions",
          "today": "today"
        },
        "completedSubmissions": {
          "title": "Completed Submissions",
          "rate": "completion rate"
        },
        "dataCollectors": {
          "title": "Data Collectors",
          "new": "new"
        },
        "problematicSubmissions": {
          "title": "Problematic Submissions"
        },
        "submissionTimeline": {
          "title": "Submission Timeline",
          "totalForPeriod": "Total for period",
          "noData": "No submission timeline data",
          "noSubmissionsInPeriod": "No submissions for selected period",
          "stats": {
            "totalSubmissions": "Total submissions",
            "maxPerDay": "Max per day",
            "trend": "Trend"
          },
          "timeframes": {
            "7days": "Last 7 days",
            "30days": "Last 30 days",
            "90days": "Last 90 days",
            "allFormData": "All form data"
          },
          "trend": {
            "stable": "No changes",
            "growth": "Growth",
            "decline": "Decline"
          },
          "hint": "Click on a bar to see detailed information for the day"
        }
      }
    },
    "summaryCard": {
      "id": "ID",
      "statusNotSet": "Status not set",
      "statusDescriptions": {
        "published": "Form is open for data collection",
        "closing": "Form is closing, new responses are limited",
        "closed": "Form is closed, new responses are not accepted",
        "draft": "Form is in draft mode, not published",
        "unknown": "Status not recognized"
      },
      "stats": {
        "today": "Today",
        "week": "This week",
        "total": "Total collected",
        "responses": "form responses",
        "fromYesterday": "from yesterday",
        "fromLastWeek": "from last week"
      },
      "info": {
        "version": "Version",
        "notSpecified": "Not specified",
        "created": "Created",
        "updated": "Updated",
        "notUpdated": "Not updated",
        "published": "Published",
        "notPublished": "Not published",
        "notSpecifiedDate": "Not specified"
      },
      "trend": {
        "title": "Filling trend for the last 7 days",
        "noData": "No data",
        "growth": "Growth",
        "decline": "Decline",
        "stable": "No changes"
      }
    },
    "attachments": {
      "title": "Form Attachments",
      "formLabel": "Form:",
      "noAttachmentsRequired": "No Attachments Required",
      "noAttachmentsDescription": "This form does not contain references to external files (images, documents, etc.).",
      "noAttachmentsHint": "If you add file references to the XLSForm, they will automatically appear here.",
      "uploadSection": {
        "supportedFormats": "Supported formats:",
        "dropZoneTitles": {
          "uploadMissing": "Upload missing files",
          "updateExisting": "Update existing files",
          "uploadFiles": "Upload files"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Expected {count} file(s): {files}",
          "updateExisting": "All files uploaded. You can replace them with new versions.",
          "uploadFiles": "Select files to upload form attachments."
        },
        "dropZoneButtons": {
          "selectFiles": "Select files",
          "updateFiles": "Update files",
          "chooseFiles": "Choose files"
        },
        "selectedFiles": "Selected files ({count})",
        "uploadButton": "Upload {count} files",
        "uploading": "Uploading...",
        "clear": "Clear",
        "chooseFiles": "Choose files"
      },
      "table": {
        "columns": {
          "name": "File Name",
          "status": "Status",
          "type": "Type",
          "size": "Size",
          "updatedAt": "Upload Date",
          "actions": "Actions"
        },
        "status": {
          "uploaded": "Uploaded",
          "missing": "Missing",
          "deleted": "Deleted",
          "unknown": "Unknown"
        },
        "actions": {
          "download": "Download",
          "delete": "Delete",
          "deleted": "Deleted",
          "missing": "Missing"
        },
        "notSpecified": "Not specified"
      },
      "messages": {
        "uploadSuccess": "Successfully uploaded {count} files",
        "uploadError": "Error uploading files: {error}",
        "fileNotFound": "File {filename} not found in selected files",
        "fileUploadSuccess": "File {filename} successfully uploaded",
        "fileUploadError": "Error uploading file {filename}: {error}",
        "downloadError": "Error downloading file {filename}: {error}",
        "deleteSuccess": "File {filename} successfully deleted",
        "deleteError": "Error deleting file {filename}: {error}",
        "invalidFilesIgnored": "The following files will be ignored (not found in expected list): {files}",
        "filesWillBeUpdated": "The following files will be updated: {files}",
        "loadingError": "Error loading attachments",
        "downloadSuccess": "File {filename} successfully downloaded",
        "fileAlreadyDeleted": "File {filename} has already been deleted or does not exist",
        "fileNotInExpectedList": "File not found in expected attachments list"
      },
      "confirmDelete": {
        "title": "Confirm Deletion",
        "message": "Are you sure you want to delete the file \"{filename}\"?",
        "warning": "This action cannot be undone.",
        "deleting": "Deleting...",
        "delete": "Delete"
      }
    }
  },
  "pageNotFound": {
    "title": "Oops! Page not found.",
    "subtitle": "404",
    "description": "The page you are looking for doesn't exist or has been moved.",
    "goBack": "Go Back",
    "goHome": "Go to Homepage",
    "copyright": "© {year} UDACAPI. All rights reserved."
  },
  "maps": {
    "tabTitle": "Map",
    "pageTitle": "Project Map",
    "subtitle": "Monitor GPS-tagged submissions in real time",
    "empty": {
      "noGeoForms": "No forms in this project have GPS questions yet.",
      "noPoints": "No submissions match the current filters."
    },
    "filters": {
      "title": "Filters",
      "forms": "Forms",
      "dateFrom": "From",
      "dateTo": "To",
      "qcStatus": "QC status",
      "enumerator": "Enumerator",
      "heatmap": "Heatmap",
      "reset": "Reset filters",
      "apply": "Apply"
    },
    "qcStatuses": {
      "any": "Any",
      "pass": "Pass",
      "fail": "Fail",
      "warning": "Warning",
      "error": "Error",
      "none": "Not validated"
    },
    "actions": {
      "export": "Export GeoJSON",
      "refresh": "Refresh",
      "settings": "Map settings",
      "openSubmission": "Open submission",
      "openFormOnMap": "View form on map"
    },
    "popup": {
      "submittedAt": "Submitted at",
      "submittedBy": "Submitted by",
      "form": "Form",
      "status": "QC status"
    },
    "truncated": "Showing the first {limit} points. Narrow the filters or enable clustering to see more.",
    "settingsDialog": {
      "title": "Project map settings",
      "defaultCenter": "Default center",
      "defaultCenterHint": "Click on the map to pick a location",
      "defaultZoom": "Default zoom",
      "defaultForms": "Default forms",
      "heatmapDefault": "Show heatmap by default",
      "coordinateFields": "Coordinate fields",
      "latitudeField": "Latitude field",
      "longitudeField": "Longitude field",
      "automaticDetection": "Use automatic detection",
      "coordinateSourceTitle": "Coordinate source",
      "coordinateMode": "Coordinate mode",
      "modeAuto": "Automatic detection",
      "modeNone": "No location data",
      "modeLatLon": "Latitude and longitude fields",
      "modeGeopoint": "Geopoint field",
      "geopointField": "Geopoint field",
      "detectedSource": "Auto-detected source: {path} · current points: {count}",
      "configureCoordinates": "Coordinate fields",
      "noMapHint": "No map points for this form. Configure coordinate fields if submissions contain locations.",
      "save": "Save",
      "cancel": "Cancel",
      "saved": "Settings saved"
    },
    "savedViews": {
      "title": "Saved views",
      "noViewsYet": "No saved views yet — save one on the project map",
      "recommended": "Recommended",
      "defaultLabel": "default",
      "saveHint": "After Apply, the map uses your filters and heatmap setting. Use Save current view to store this setup under a name (managers only).",
      "saveCurrent": "Save current view",
      "updateCurrent": "Update view",
      "delete": "Delete view",
      "name": "View name",
      "pinAsDefault": "Pin as default",
      "pin": "Pin view",
      "saved": "View saved",
      "updated": "View updated",
      "deleted": "View deleted",
      "saveFailed": "Could not save view. Check that the API is deployed and DB migrations include project_map_views.",
      "updateFailed": "Could not update view.",
      "deleteFailed": "Could not delete view."
    },
    "tileConfig": {
      "sectionTitle": "Map tile server",
      "sectionDescription": "Provide a custom tile-server URL for your organization. Leave blank to use the public OpenStreetMap tiles.",
      "url": "Tile URL template",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Attribution",
      "subdomains": "Subdomains",
      "maxZoom": "Max zoom",
      "minZoom": "Min zoom",
      "test": "Test tile URL",
      "configure": "Configure",
      "edit": "Edit",
      "defaultTiles": "Using OpenStreetMap public tiles",
      "zoom": "Zoom",
      "clear": "Clear",
      "save": "Save",
      "saved": "Tile config saved",
      "cleared": "Custom tile server cleared"
    }
  },
  "shareDashboard": {
    "shareButton": "Share dashboard",
    "dialogTitle": "Share dashboard",
    "dialogHint": "Create a secret link for clients to open a live read-only briefing. Optional PIN recommended.",
    "label": "Label",
    "pinOptional": "PIN (optional)",
    "pinPlaceholder": "At least 4 characters",
    "pin": "PIN",
    "create": "Create link",
    "created": "Share link created",
    "createError": "Could not create share link",
    "copyOnce": "Copy now — the full link is shown only once",
    "copy": "Copy",
    "copied": "Copied",
    "copyError": "Could not copy",
    "existing": "Existing links",
    "refresh": "Refresh",
    "loadingLinks": "Loading share links…",
    "empty": "No share links yet",
    "untitled": "Untitled link",
    "overviewHint": "Live collection summary for this shared form",
    "loadFormsError": "Could not load forms",
    "revoke": "Revoke",
    "revokeTitle": "Revoke share link",
    "revokeConfirm": "Clients with this link will lose access immediately.",
    "revokeError": "Could not revoke link",
    "revoked": "Revoked",
    "expired": "Expired",
    "expires": "Expires",
    "loadError": "Could not load share links",
    "openBriefing": "Open briefing",
    "pinGateHint": "Enter the PIN provided with this link.",
    "invalidPin": "Invalid PIN",
    "expiredLink": "This link has expired",
    "askManager": "Ask the project manager for a new link",
    "loading": "Opening briefing…",
    "briefing": "Field briefing",
    "updated": "Updated",
    "pickForm": "Choose a form to open",
    "backToForms": "All forms",
    "submissions": "Submissions",
    "noSubmissions": "No submissions in this form yet",
    "view": "View",
    "submissionDetail": "Submission",
    "close": "Close",
    "totalSubmissions": "Submissions",
    "today": "Today",
    "thisWeek": "This week",
    "collectors": "Collectors",
    "analyticsError": "Could not load collection summary",
    "submissionsError": "Could not load submissions"
  }
}
